import { api } from './emptyApi'

export const addTagTypes = [
  'Vehicle Efficiency',
  'Vehicle Catalog',
  'Vehicle Charge Curves',
  'Organizations',
  'Vehicles',
  'charge-curves',
  'energy-estimates',
  'fits',
  'health',
  'visits',
  'plans',
  'efficiency',
  'state-forecast'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getModel: build.query<GetModelResponse, GetModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicles/${queryArg.vehicleId}/efficiency-model` }),
        providesTags: ['Vehicle Efficiency']
      }),
      upsertModel: build.mutation<UpsertModelResponse, UpsertModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicles/${queryArg.vehicleId}/efficiency-model`,
          method: 'PUT',
          body: queryArg.vehicleEfficiencyModelParams
        }),
        invalidatesTags: ['Vehicle Efficiency']
      }),
      listWmis: build.query<ListWmisResponse, ListWmisArgs>({
        query: () => ({ url: `/api/v1/vehicle-catalog/wmis` }),
        providesTags: ['Vehicle Catalog']
      }),
      saveWmi: build.mutation<SaveWmiResponse, SaveWmiArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/wmis`,
          method: 'PUT',
          body: queryArg.vehicleCatalogWmiParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      updatePowerCurve: build.mutation<UpdatePowerCurveResponse, UpdatePowerCurveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/power-curves/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.vehicleCatalogPowerCurveUpdateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      deletePowerCurve: build.mutation<DeletePowerCurveResponse, DeletePowerCurveArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/power-curves/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      fitPowerCurve: build.mutation<FitPowerCurveResponse, FitPowerCurveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/power-curves/fit`,
          method: 'PUT',
          body: queryArg.vehicleCatalogPowerCurveFitParams
        }),
        invalidatesTags: ['Vehicle Charge Curves']
      }),
      getManufacturer: build.query<GetManufacturerResponse, GetManufacturerArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/manufacturers/${queryArg.id}` }),
        providesTags: ['Vehicle Catalog']
      }),
      updateManufacturer: build.mutation<UpdateManufacturerResponse, UpdateManufacturerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/manufacturers/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.vehicleCatalogManufacturerUpdateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      deleteManufacturer: build.mutation<DeleteManufacturerResponse, DeleteManufacturerArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/manufacturers/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      getMakeModel: build.query<GetMakeModelResponse, GetMakeModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}` }),
        providesTags: ['Vehicle Catalog']
      }),
      updateMakeModel: build.mutation<UpdateMakeModelResponse, UpdateMakeModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.vehicleCatalogMakeModelUpdateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      deleteMakeModel: build.mutation<DeleteMakeModelResponse, DeleteMakeModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      getCapabilitySet: build.query<GetCapabilitySetResponse, GetCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/capability-sets/${queryArg.id}` }),
        providesTags: ['Vehicle Catalog']
      }),
      updateCapabilitySet: build.mutation<UpdateCapabilitySetResponse, UpdateCapabilitySetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/capability-sets/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.vehicleCatalogCapabilitySetUpdateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      deleteCapabilitySet: build.mutation<DeleteCapabilitySetResponse, DeleteCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/capability-sets/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      getCohort: build.query<GetCohortResponse, GetCohortArgs>({
        query: (queryArg) => ({ url: `/api/v1/efficiency-cohorts/${queryArg.cohortType}/${queryArg.cohortId}` }),
        providesTags: ['Vehicle Efficiency']
      }),
      upsertCohort: build.mutation<UpsertCohortResponse, UpsertCohortArgs>({
        query: (queryArg) => ({
          url: `/api/v1/efficiency-cohorts/${queryArg.cohortType}/${queryArg.cohortId}`,
          method: 'PUT',
          body: queryArg.vehicleEfficiencyCohortModelParams
        }),
        invalidatesTags: ['Vehicle Efficiency']
      }),
      getChargeModel: build.query<GetChargeModelResponse, GetChargeModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/charge-models/${queryArg.capabilitySetId}` }),
        providesTags: ['Vehicle Charge Curves']
      }),
      upsertChargeModel: build.mutation<UpsertChargeModelResponse, UpsertChargeModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/charge-models/${queryArg.capabilitySetId}`,
          method: 'PUT',
          body: queryArg.vehicleChargeModelFitParams
        }),
        invalidatesTags: ['Vehicle Charge Curves']
      }),
      resetModel: build.mutation<ResetModelResponse, ResetModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicles/${queryArg.vehicleId}/efficiency-model/reset`,
          method: 'POST',
          body: queryArg.vehicleEfficiencyModelResetParams
        }),
        invalidatesTags: ['Vehicle Efficiency']
      }),
      propose: build.mutation<ProposeResponse, ProposeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/proposals`,
          method: 'POST',
          body: queryArg.vehicleCatalogProposalParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      listPowerCurves: build.query<ListPowerCurvesResponse, ListPowerCurvesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/power-curves`,
          params: {
            capabilitySetId: queryArg.capabilitySetId
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      createPowerCurve: build.mutation<CreatePowerCurveResponse, CreatePowerCurveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/power-curves`,
          method: 'POST',
          body: queryArg.vehicleCatalogPowerCurveCreateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      listManufacturers: build.query<ListManufacturersResponse, ListManufacturersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/manufacturers`,
          params: {
            status: queryArg.status
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      createManufacturer: build.mutation<CreateManufacturerResponse, CreateManufacturerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/manufacturers`,
          method: 'POST',
          body: queryArg.vehicleCatalogManufacturerCreateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      mergeManufacturer: build.mutation<MergeManufacturerResponse, MergeManufacturerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/manufacturers/${queryArg.id}/merge`,
          method: 'POST',
          body: queryArg.vehicleCatalogMergeParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      listMakeModels: build.query<ListMakeModelsResponse, ListMakeModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models`,
          params: {
            manufacturerId: queryArg.manufacturerId,
            status: queryArg.status
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      createMakeModel: build.mutation<CreateMakeModelResponse, CreateMakeModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models`,
          method: 'POST',
          body: queryArg.vehicleCatalogMakeModelCreateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      listSignatures: build.query<ListSignaturesResponse, ListSignaturesArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}/signatures` }),
        providesTags: ['Vehicle Catalog']
      }),
      createSignature: build.mutation<CreateSignatureResponse, CreateSignatureArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}/signatures`,
          method: 'POST',
          body: queryArg.vehicleMakeModelSignatureCreateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      mergeMakeModel: build.mutation<MergeMakeModelResponse, MergeMakeModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}/merge`,
          method: 'POST',
          body: queryArg.vehicleCatalogMergeParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      listCapabilitySets: build.query<ListCapabilitySetsResponse, ListCapabilitySetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/capability-sets`,
          params: {
            makeModelId: queryArg.makeModelId
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      createCapabilitySet: build.mutation<CreateCapabilitySetResponse, CreateCapabilitySetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/capability-sets`,
          method: 'POST',
          body: queryArg.vehicleCatalogCapabilitySetCreateParams
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      resetModels: build.mutation<ResetModelsResponse, ResetModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/efficiency-models/reset`,
          method: 'POST',
          body: queryArg.vehicleEfficiencyModelBulkResetParams
        }),
        invalidatesTags: ['Vehicle Efficiency']
      }),
      backfill: build.mutation<BackfillResponse, BackfillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/efficiency-models/backfill`,
          method: 'POST',
          params: {
            count: queryArg.count
          }
        }),
        invalidatesTags: ['Vehicle Efficiency']
      }),
      resetChargeModel: build.mutation<ResetChargeModelResponse, ResetChargeModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/charge-models/${queryArg.capabilitySetId}/reset`,
          method: 'POST',
          body: queryArg.vehicleChargeModelResetParams,
          params: {
            trainingFrom: queryArg.trainingFrom
          }
        }),
        invalidatesTags: ['Vehicle Charge Curves']
      }),
      moveApiKeyToUsagePlan: build.mutation<MoveApiKeyToUsagePlanResponse, MoveApiKeyToUsagePlanArgs>({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/keys/${queryArg.keyId}/move-plan`,
          method: 'POST',
          body: queryArg.apiKeyMovePlanParams
        }),
        invalidatesTags: ['Organizations']
      }),
      registerApiKeyByOrganizationId: build.mutation<
        RegisterApiKeyByOrganizationIdResponse,
        RegisterApiKeyByOrganizationIdArgs
      >({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/keys/register`,
          method: 'POST',
          body: queryArg.organizationApiKeyRegisterParams
        }),
        invalidatesTags: ['Organizations']
      }),
      getUsagePlanByOrganizationId: build.query<GetUsagePlanByOrganizationIdResponse, GetUsagePlanByOrganizationIdArgs>(
        {
          query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/usage-plans/${queryArg.usagePlanId}` }),
          providesTags: ['Organizations']
        }
      ),
      updateUsagePlanByOrganizationId: build.mutation<
        UpdateUsagePlanByOrganizationIdResponse,
        UpdateUsagePlanByOrganizationIdArgs
      >({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/usage-plans/${queryArg.usagePlanId}`,
          method: 'PATCH',
          body: queryArg.usagePlanUpdateParams
        }),
        invalidatesTags: ['Organizations']
      }),
      updateApiKeyByOrganizationId: build.mutation<
        UpdateApiKeyByOrganizationIdResponse,
        UpdateApiKeyByOrganizationIdArgs
      >({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/keys/${queryArg.keyId}`,
          method: 'PATCH',
          body: queryArg.organizationApiKeyUpdateParams
        }),
        invalidatesTags: ['Organizations']
      }),
      getVehicleCapabilitySet: build.query<GetVehicleCapabilitySetResponse, GetVehicleCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/vehicles/${queryArg.id}/capability-set` }),
        providesTags: ['Vehicles']
      }),
      getSamples: build.query<GetSamplesResponse, GetSamplesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicles/${queryArg.vehicleId}/efficiency-samples`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Vehicle Efficiency']
      }),
      getWmi: build.query<GetWmiResponse, GetWmiArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/wmis/${queryArg.wmi}` }),
        providesTags: ['Vehicle Catalog']
      }),
      deleteWmi: build.mutation<DeleteWmiResponse, DeleteWmiArgs>({
        query: (queryArg) => ({ url: `/api/v1/vehicle-catalog/wmis/${queryArg.wmi}`, method: 'DELETE' }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      getVinDecode: build.query<GetVinDecodeResponse, GetVinDecodeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/vin-decodes/${queryArg.vin}`,
          params: {
            refresh: queryArg.refresh
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      listCapabilitySetVehicles: build.query<ListCapabilitySetVehiclesResponse, ListCapabilitySetVehiclesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/capability-sets/${queryArg.id}/vehicles`,
          params: {
            afterVehicleId: queryArg.afterVehicleId,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Vehicle Catalog']
      }),
      listModels: build.query<ListModelsResponse, ListModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/efficiency-models`,
          params: {
            page: queryArg.page,
            count: queryArg.count,
            status: queryArg.status,
            orderBy: queryArg.orderBy,
            afterVehicleId: queryArg.afterVehicleId,
            vehicleIds: queryArg.vehicleIds
          }
        }),
        providesTags: ['Vehicle Efficiency']
      }),
      listCohorts: build.query<ListCohortsResponse, ListCohortsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/efficiency-cohorts`,
          params: {
            cohortType: queryArg.cohortType,
            cohortId: queryArg.cohortId
          }
        }),
        providesTags: ['Vehicle Efficiency']
      }),
      listChargeModels: build.query<ListChargeModelsResponse, ListChargeModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/charge-models`,
          params: {
            orderBy: queryArg.orderBy,
            afterCapabilitySetId: queryArg.afterCapabilitySetId,
            count: queryArg.count
          }
        }),
        providesTags: ['Vehicle Charge Curves']
      }),
      getUsagePlansByOrganizationId: build.query<
        GetUsagePlansByOrganizationIdResponse,
        GetUsagePlansByOrganizationIdArgs
      >({
        query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/usage-plans` }),
        providesTags: ['Organizations']
      }),
      getApiKeyUsageByOrganizationId: build.query<
        GetApiKeyUsageByOrganizationIdResponse,
        GetApiKeyUsageByOrganizationIdArgs
      >({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/keys/${queryArg.keyId}/usage`,
          params: {
            startDate: queryArg.startDate,
            endDate: queryArg.endDate
          }
        }),
        providesTags: ['Organizations']
      }),
      getApiKeySummariesByOrganizationId: build.query<
        GetApiKeySummariesByOrganizationIdResponse,
        GetApiKeySummariesByOrganizationIdArgs
      >({
        query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/keys/summary` }),
        providesTags: ['Organizations']
      }),
      deleteSignature: build.mutation<DeleteSignatureResponse, DeleteSignatureArgs>({
        query: (queryArg) => ({
          url: `/api/v1/vehicle-catalog/make-models/${queryArg.id}/signatures/${queryArg.signatureId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Vehicle Catalog']
      }),
      capabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGet: build.query<
        CapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetResponse,
        CapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/capability-sets/${queryArg.capabilitySetId}/charge-curve`,
          params: {
            chargerClass: queryArg.chargerClass,
            direction: queryArg.direction
          }
        }),
        providesTags: ['charge-curves']
      }),
      refitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPost: build.mutation<
        RefitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPostResponse,
        RefitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/capability-sets/${queryArg.capabilitySetId}/charge-curve/refit`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['charge-curves']
      }),
      capabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGet: build.query<
        CapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetResponse,
        CapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/capability-sets/${queryArg.capabilitySetId}/charge-model`
        }),
        providesTags: ['charge-curves']
      }),
      estimateEnergyV1EnergyEstimatesPost: build.mutation<
        EstimateEnergyV1EnergyEstimatesPostResponse,
        EstimateEnergyV1EnergyEstimatesPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/energy-estimates`,
          method: 'POST',
          body: queryArg.energyEstimateIn
        }),
        invalidatesTags: ['energy-estimates']
      }),
      fitChargeCurvesV1FitsChargeCurvesPost: build.mutation<
        FitChargeCurvesV1FitsChargeCurvesPostResponse,
        FitChargeCurvesV1FitsChargeCurvesPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/fits/charge-curves`,
          method: 'POST',
          body: queryArg.chargeCurveFitIn
        }),
        invalidatesTags: ['fits']
      }),
      fitEfficiencyV1FitsEfficiencyPost: build.mutation<
        FitEfficiencyV1FitsEfficiencyPostResponse,
        FitEfficiencyV1FitsEfficiencyPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/fits/efficiency`,
          method: 'POST',
          body: queryArg.efficiencyFitIn
        }),
        invalidatesTags: ['fits']
      }),
      latestFitRunV1FitsRunsLatestGet: build.query<
        LatestFitRunV1FitsRunsLatestGetResponse,
        LatestFitRunV1FitsRunsLatestGetArgs
      >({
        query: () => ({ url: `/vehicle-intelligence/v1/fits/runs/latest` }),
        providesTags: ['fits']
      }),
      healthV1HealthGet: build.query<HealthV1HealthGetResponse, HealthV1HealthGetArgs>({
        query: () => ({ url: `/vehicle-intelligence/v1/health` }),
        providesTags: ['health']
      }),
      listPlacesV1PlacesGet: build.query<ListPlacesV1PlacesGetResponse, ListPlacesV1PlacesGetArgs>({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/places`,
          params: {
            kind: queryArg.kind,
            siteId: queryArg.siteId,
            limit: queryArg.limit,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['visits']
      }),
      getPlaceV1PlacesPlaceIdGet: build.query<GetPlaceV1PlacesPlaceIdGetResponse, GetPlaceV1PlacesPlaceIdGetArgs>({
        query: (queryArg) => ({ url: `/vehicle-intelligence/v1/places/${queryArg.placeId}` }),
        providesTags: ['visits']
      }),
      listPlaceVisitsV1PlacesPlaceIdVisitsGet: build.query<
        ListPlaceVisitsV1PlacesPlaceIdVisitsGetResponse,
        ListPlaceVisitsV1PlacesPlaceIdVisitsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/places/${queryArg.placeId}/visits`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limit: queryArg.limit,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['visits']
      }),
      listPlanEvaluationsV1PlansEvaluationsGet: build.query<
        ListPlanEvaluationsV1PlansEvaluationsGetResponse,
        ListPlanEvaluationsV1PlansEvaluationsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/evaluations`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['plans']
      }),
      getPlanEvaluationV1PlansEvaluationsDayGet: build.query<
        GetPlanEvaluationV1PlansEvaluationsDayGetResponse,
        GetPlanEvaluationV1PlansEvaluationsDayGetArgs
      >({
        query: (queryArg) => ({ url: `/vehicle-intelligence/v1/plans/evaluations/${queryArg.day}` }),
        providesTags: ['plans']
      }),
      getPlansEnvironmentHealthV1PlansHealthGet: build.query<
        GetPlansEnvironmentHealthV1PlansHealthGetResponse,
        GetPlansEnvironmentHealthV1PlansHealthGetArgs
      >({
        query: () => ({ url: `/vehicle-intelligence/v1/plans/health` }),
        providesTags: ['plans']
      }),
      comparePlansV1PlansSitesSiteIdCompareGet: build.query<
        ComparePlansV1PlansSitesSiteIdCompareGetResponse,
        ComparePlansV1PlansSitesSiteIdCompareGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/compare`,
          params: {
            planIds: queryArg.planIds
          }
        }),
        providesTags: ['plans']
      }),
      getDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGet: build.query<
        GetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetResponse,
        GetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/day-ahead/${queryArg.serviceDate}`
        }),
        providesTags: ['plans']
      }),
      getPlansSiteHealthV1PlansSitesSiteIdHealthGet: build.query<
        GetPlansSiteHealthV1PlansSitesSiteIdHealthGetResponse,
        GetPlansSiteHealthV1PlansSitesSiteIdHealthGetArgs
      >({
        query: (queryArg) => ({ url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/health` }),
        providesTags: ['plans']
      }),
      listPlanModelsV1PlansSitesSiteIdModelsGet: build.query<
        ListPlanModelsV1PlansSitesSiteIdModelsGetResponse,
        ListPlanModelsV1PlansSitesSiteIdModelsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/models`,
          params: {
            capability: queryArg.capability,
            provider: queryArg.provider,
            windowDays: queryArg.windowDays
          }
        }),
        providesTags: ['plans']
      }),
      listPlanOutcomesV1PlansSitesSiteIdOutcomesGet: build.query<
        ListPlanOutcomesV1PlansSitesSiteIdOutcomesGetResponse,
        ListPlanOutcomesV1PlansSitesSiteIdOutcomesGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/outcomes`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            pageSize: queryArg.pageSize,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['plans']
      }),
      listPlanVersionsV1PlansSitesSiteIdVersionsGet: build.query<
        ListPlanVersionsV1PlansSitesSiteIdVersionsGetResponse,
        ListPlanVersionsV1PlansSitesSiteIdVersionsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions`,
          params: {
            date: queryArg.date,
            timeZone: queryArg.timeZone,
            from: queryArg['from'],
            to: queryArg.to,
            kind: queryArg.kind,
            pageSize: queryArg.pageSize,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['plans']
      }),
      getPlanVersionV1PlansSitesSiteIdVersionsPlanIdGet: build.query<
        GetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetResponse,
        GetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}`
        }),
        providesTags: ['plans']
      }),
      diffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGet: build.query<
        DiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetResponse,
        DiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/diff`,
          params: {
            from: queryArg['from']
          }
        }),
        providesTags: ['plans']
      }),
      explainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGet: build.query<
        ExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetResponse,
        ExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/explanations`,
          params: {
            subjectType: queryArg.subjectType,
            subjectId: queryArg.subjectId,
            aspect: queryArg.aspect
          }
        }),
        providesTags: ['plans']
      }),
      listPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGet: build.query<
        ListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetResponse,
        ListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/forecasts`,
          params: {
            subjectType: queryArg.subjectType,
            subjectId: queryArg.subjectId,
            quantity: queryArg.quantity
          }
        }),
        providesTags: ['plans']
      }),
      listPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGet: build.query<
        ListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetResponse,
        ListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/options`,
          params: {
            subjectType: queryArg.subjectType,
            subjectId: queryArg.subjectId,
            family: queryArg.family
          }
        }),
        providesTags: ['plans']
      }),
      getPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGet: build.query<
        GetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetResponse,
        GetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/options/${queryArg.optionId}`
        }),
        providesTags: ['plans']
      }),
      getPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGet: build.query<
        GetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetResponse,
        GetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/timeline`,
          params: {
            include: queryArg.include
          }
        }),
        providesTags: ['plans']
      }),
      listPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGet: build.query<
        ListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetResponse,
        ListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/plans/sites/${queryArg.siteId}/versions/${queryArg.planId}/verdicts`,
          params: {
            routeId: queryArg.routeId,
            verdict: queryArg.verdict
          }
        }),
        providesTags: ['plans']
      }),
      evaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGet: build.query<
        EvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetResponse,
        EvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/sites/${queryArg.siteId}/efficiency/evaluate`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            resolution: queryArg.resolution
          }
        }),
        providesTags: ['efficiency']
      }),
      siteVisitsDayV1SitesSiteIdVisitsDaysDateGet: build.query<
        SiteVisitsDayV1SitesSiteIdVisitsDaysDateGetResponse,
        SiteVisitsDayV1SitesSiteIdVisitsDaysDateGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/sites/${queryArg.siteId}/visits/days/${queryArg.date}`
        }),
        providesTags: ['visits']
      }),
      vehicleChargeCurveV1VehiclesVehicleIdChargeCurveGet: build.query<
        VehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetResponse,
        VehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/charge-curve`,
          params: {
            chargerClass: queryArg.chargerClass,
            direction: queryArg.direction
          }
        }),
        providesTags: ['charge-curves']
      }),
      vehicleChargeDurationV1VehiclesVehicleIdChargeDurationPost: build.mutation<
        VehicleChargeDurationV1VehiclesVehicleIdChargeDurationPostResponse,
        VehicleChargeDurationV1VehiclesVehicleIdChargeDurationPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/charge-duration`,
          method: 'POST',
          body: queryArg.chargeDurationIn
        }),
        invalidatesTags: ['charge-curves']
      }),
      getEfficiencyModelV1VehiclesVehicleIdEfficiencyGet: build.query<
        GetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetResponse,
        GetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetArgs
      >({
        query: (queryArg) => ({ url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency` }),
        providesTags: ['efficiency']
      }),
      rebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPost: build.mutation<
        RebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPostResponse,
        RebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency-blocks/rebuild`,
          method: 'POST'
        }),
        invalidatesTags: ['efficiency']
      }),
      refitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPost: build.mutation<
        RefitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPostResponse,
        RefitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency-model/refit`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun,
            asOf: queryArg.asOf
          }
        }),
        invalidatesTags: ['efficiency']
      }),
      evaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGet: build.query<
        EvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetResponse,
        EvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency/evaluate`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            siteId: queryArg.siteId,
            resolution: queryArg.resolution
          }
        }),
        providesTags: ['efficiency']
      }),
      efficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGet: build.query<
        EfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetResponse,
        EfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency/history`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            bucket: queryArg.bucket,
            timeZone: queryArg.timeZone
          }
        }),
        providesTags: ['efficiency']
      }),
      resetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPost: build.mutation<
        ResetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPostResponse,
        ResetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPostArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency/reset`,
          method: 'POST',
          body: queryArg.resetIn
        }),
        invalidatesTags: ['efficiency']
      }),
      efficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGet: build.query<
        EfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetResponse,
        EfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/efficiency/samples`,
          params: {
            kind: queryArg.kind,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            pageSize: queryArg.pageSize
          }
        }),
        providesTags: ['efficiency']
      }),
      getStateForecastV1VehiclesVehicleIdStateForecastGet: build.query<
        GetStateForecastV1VehiclesVehicleIdStateForecastGetResponse,
        GetStateForecastV1VehiclesVehicleIdStateForecastGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/state-forecast`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            resolution: queryArg.resolution,
            include: queryArg.include
          }
        }),
        providesTags: ['state-forecast']
      }),
      listVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGet: build.query<
        ListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetResponse,
        ListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/visit-events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limit: queryArg.limit,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['visits']
      }),
      listVehicleVisitsV1VehiclesVehicleIdVisitsGet: build.query<
        ListVehicleVisitsV1VehiclesVehicleIdVisitsGetResponse,
        ListVehicleVisitsV1VehiclesVehicleIdVisitsGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/visits`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            placeKind: queryArg.placeKind,
            placeId: queryArg.placeId,
            openOnly: queryArg.openOnly,
            limit: queryArg.limit,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['visits']
      }),
      vehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGet: build.query<
        VehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetResponse,
        VehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/vehicles/${queryArg.vehicleId}/visits/summary`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            timeZone: queryArg.timeZone
          }
        }),
        providesTags: ['visits']
      }),
      listOpenVisitsV1VisitsOpenGet: build.query<
        ListOpenVisitsV1VisitsOpenGetResponse,
        ListOpenVisitsV1VisitsOpenGetArgs
      >({
        query: (queryArg) => ({
          url: `/vehicle-intelligence/v1/visits/open`,
          params: {
            placeId: queryArg.placeId,
            placeKind: queryArg.placeKind,
            limit: queryArg.limit,
            cursor: queryArg.cursor
          }
        }),
        providesTags: ['visits']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetModelResponse = /** status 200 OK */ VehicleEfficiencyModel
export type GetModelArgs = {
  vehicleId: string
}
export type UpsertModelResponse = /** status 200 OK */ VehicleEfficiencyModel
export type UpsertModelArgs = {
  vehicleId: string
  vehicleEfficiencyModelParams: VehicleEfficiencyModelParams
}
export type ListWmisResponse = /** status 200 OK */ VehicleCatalogWmi[]
export type ListWmisArgs = void
export type SaveWmiResponse = /** status 200 OK */ VehicleCatalogWmi
export type SaveWmiArgs = {
  vehicleCatalogWmiParams: VehicleCatalogWmiParams
}
export type UpdatePowerCurveResponse = /** status 200 OK */ VehicleCatalogPowerCurve
export type UpdatePowerCurveArgs = {
  id: string
  vehicleCatalogPowerCurveUpdateParams: VehicleCatalogPowerCurveUpdateParams
}
export type DeletePowerCurveResponse = unknown
export type DeletePowerCurveArgs = {
  id: string
}
export type FitPowerCurveResponse = /** status 200 OK */ VehicleCatalogPowerCurve
export type FitPowerCurveArgs = {
  vehicleCatalogPowerCurveFitParams: VehicleCatalogPowerCurveFitParams
}
export type GetManufacturerResponse = /** status 200 OK */ VehicleCatalogManufacturer
export type GetManufacturerArgs = {
  id: string
}
export type UpdateManufacturerResponse = /** status 200 OK */ VehicleCatalogManufacturer
export type UpdateManufacturerArgs = {
  id: string
  vehicleCatalogManufacturerUpdateParams: VehicleCatalogManufacturerUpdateParams
}
export type DeleteManufacturerResponse = unknown
export type DeleteManufacturerArgs = {
  id: string
}
export type GetMakeModelResponse = /** status 200 OK */ VehicleCatalogMakeModel
export type GetMakeModelArgs = {
  id: string
}
export type UpdateMakeModelResponse = /** status 200 OK */ VehicleCatalogMakeModel
export type UpdateMakeModelArgs = {
  id: string
  vehicleCatalogMakeModelUpdateParams: VehicleCatalogMakeModelUpdateParams
}
export type DeleteMakeModelResponse = unknown
export type DeleteMakeModelArgs = {
  id: string
}
export type GetCapabilitySetResponse = /** status 200 OK */ VehicleCatalogCapabilitySet
export type GetCapabilitySetArgs = {
  id: string
}
export type UpdateCapabilitySetResponse = /** status 200 OK */ VehicleCatalogCapabilitySet
export type UpdateCapabilitySetArgs = {
  id: string
  vehicleCatalogCapabilitySetUpdateParams: VehicleCatalogCapabilitySetUpdateParams
}
export type DeleteCapabilitySetResponse = unknown
export type DeleteCapabilitySetArgs = {
  id: string
}
export type GetCohortResponse = /** status 200 OK */ VehicleEfficiencyCohortModel
export type GetCohortArgs = {
  cohortType: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  cohortId: string
}
export type UpsertCohortResponse = /** status 200 OK */ VehicleEfficiencyCohortModel
export type UpsertCohortArgs = {
  cohortType: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  cohortId: string
  vehicleEfficiencyCohortModelParams: VehicleEfficiencyCohortModelParams
}
export type GetChargeModelResponse = /** status 200 OK */ VehicleChargeModel
export type GetChargeModelArgs = {
  capabilitySetId: string
}
export type UpsertChargeModelResponse = /** status 200 OK */ VehicleChargeModel
export type UpsertChargeModelArgs = {
  capabilitySetId: string
  vehicleChargeModelFitParams: VehicleChargeModelFitParams
}
export type ResetModelResponse = /** status 200 OK */ VehicleEfficiencyModel
export type ResetModelArgs = {
  vehicleId: string
  vehicleEfficiencyModelResetParams: VehicleEfficiencyModelResetParams
}
export type ProposeResponse = /** status 200 OK */ VehicleCatalogProposal
export type ProposeArgs = {
  vehicleCatalogProposalParams: VehicleCatalogProposalParams
}
export type ListPowerCurvesResponse = /** status 200 OK */ VehicleCatalogPowerCurve[]
export type ListPowerCurvesArgs = {
  capabilitySetId: string
}
export type CreatePowerCurveResponse = /** status 200 OK */ VehicleCatalogPowerCurve
export type CreatePowerCurveArgs = {
  vehicleCatalogPowerCurveCreateParams: VehicleCatalogPowerCurveCreateParams
}
export type ListManufacturersResponse = /** status 200 OK */ VehicleCatalogManufacturer[]
export type ListManufacturersArgs = {
  /** Only entries with this verification status */
  status?: 'PROPOSED' | 'VERIFIED' | 'REJECTED' | 'MERGED'
}
export type CreateManufacturerResponse = /** status 200 OK */ VehicleCatalogManufacturer
export type CreateManufacturerArgs = {
  vehicleCatalogManufacturerCreateParams: VehicleCatalogManufacturerCreateParams
}
export type MergeManufacturerResponse = /** status 200 OK */ VehicleCatalogManufacturer
export type MergeManufacturerArgs = {
  id: string
  vehicleCatalogMergeParams: VehicleCatalogMergeParams
}
export type ListMakeModelsResponse = /** status 200 OK */ VehicleCatalogMakeModel[]
export type ListMakeModelsArgs = {
  manufacturerId?: string
  status?: 'PROPOSED' | 'VERIFIED' | 'REJECTED' | 'MERGED'
}
export type CreateMakeModelResponse = /** status 200 OK */ VehicleCatalogMakeModel
export type CreateMakeModelArgs = {
  vehicleCatalogMakeModelCreateParams: VehicleCatalogMakeModelCreateParams
}
export type ListSignaturesResponse = /** status 200 OK */ VehicleMakeModelSignature[]
export type ListSignaturesArgs = {
  id: string
}
export type CreateSignatureResponse = /** status 200 OK */ VehicleMakeModelSignature
export type CreateSignatureArgs = {
  id: string
  vehicleMakeModelSignatureCreateParams: VehicleMakeModelSignatureCreateParams
}
export type MergeMakeModelResponse = /** status 200 OK */ VehicleCatalogMakeModel
export type MergeMakeModelArgs = {
  id: string
  vehicleCatalogMergeParams: VehicleCatalogMergeParams
}
export type ListCapabilitySetsResponse = /** status 200 OK */ VehicleCatalogCapabilitySet[]
export type ListCapabilitySetsArgs = {
  makeModelId: string
}
export type CreateCapabilitySetResponse = /** status 200 OK */ VehicleCatalogCapabilitySet
export type CreateCapabilitySetArgs = {
  vehicleCatalogCapabilitySetCreateParams: VehicleCatalogCapabilitySetCreateParams
}
export type ResetModelsResponse = /** status 200 OK */ VehicleEfficiencyModelResetResult
export type ResetModelsArgs = {
  vehicleEfficiencyModelBulkResetParams: VehicleEfficiencyModelBulkResetParams
}
export type BackfillResponse = /** status 200 OK */ VehicleEfficiencyBackfillResult
export type BackfillArgs = {
  /** Vehicles to process in this call, at most 5000 */
  count?: number
}
export type ResetChargeModelResponse = /** status 200 OK */ VehicleChargeModel
export type ResetChargeModelArgs = {
  capabilitySetId: string
  /** ISO-8601 instant sessions are ignored before; defaults to now */
  trainingFrom?: string
  vehicleChargeModelResetParams: VehicleChargeModelResetParams
}
export type MoveApiKeyToUsagePlanResponse = /** status 200 OK */ OrganizationApiKeySummary
export type MoveApiKeyToUsagePlanArgs = {
  id: string
  keyId: string
  apiKeyMovePlanParams: ApiKeyMovePlanParams
}
export type RegisterApiKeyByOrganizationIdResponse = /** status 200 OK */ OrganizationApiKeySummary
export type RegisterApiKeyByOrganizationIdArgs = {
  id: string
  organizationApiKeyRegisterParams: OrganizationApiKeyRegisterParamsWrite
}
export type GetUsagePlanByOrganizationIdResponse = /** status 200 OK */ UsagePlan
export type GetUsagePlanByOrganizationIdArgs = {
  id: string
  usagePlanId: string
}
export type UpdateUsagePlanByOrganizationIdResponse = /** status 200 OK */ UsagePlan
export type UpdateUsagePlanByOrganizationIdArgs = {
  id: string
  usagePlanId: string
  usagePlanUpdateParams: UsagePlanUpdateParams
}
export type UpdateApiKeyByOrganizationIdResponse = /** status 200 OK */ OrganizationApiKeySummary
export type UpdateApiKeyByOrganizationIdArgs = {
  id: string
  keyId: string
  organizationApiKeyUpdateParams: OrganizationApiKeyUpdateParams
}
export type GetVehicleCapabilitySetResponse = /** status 200 OK */ VehicleCatalogResolution
export type GetVehicleCapabilitySetArgs = {
  id: string
}
export type GetSamplesResponse = /** status 200 OK */ VehicleEfficiencySample[]
export type GetSamplesArgs = {
  vehicleId: string
  /** ISO-8601 instant, defaults to 90 days before to */
  from?: string
  /** ISO-8601 instant, defaults to now */
  to?: string
}
export type GetWmiResponse = /** status 200 OK */ VehicleCatalogWmi
export type GetWmiArgs = {
  wmi: string
}
export type DeleteWmiResponse = unknown
export type DeleteWmiArgs = {
  wmi: string
}
export type GetVinDecodeResponse = /** status 200 OK */ VehicleVinDecode
export type GetVinDecodeArgs = {
  vin: string
  /** Ask vPIC again even when a decode is cached */
  refresh?: boolean
}
export type ListCapabilitySetVehiclesResponse = /** status 200 OK */ PagedResponseV2VehicleModel
export type ListCapabilitySetVehiclesArgs = {
  id: string
  /** Keyset cursor: only vehicles with an id greater than this one */
  afterVehicleId?: string
  /** Zero-based page, applied after the cursor */
  page?: number
  /** Page size, default 500, at most 1000 */
  count?: number
}
export type ListModelsResponse = /** status 200 OK */ PagedResponseV2VehicleEfficiencyModelListItem
export type ListModelsArgs = {
  /** Page number */
  page?: number
  /** Rows per page, at most 500 */
  count?: number
  /** Only models with this status */
  status?: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** Sort order: lastFittedAt (default; never fitted first, then oldest fit) or vehicleId (ascending, stable under concurrent fits) */
  orderBy?: string
  /** Keyset cursor for orderBy=vehicleId: only rows whose vehicleId is greater than this; pass the last vehicleId of the previous page */
  afterVehicleId?: string
  /** Only these vehicles' models (repeated or comma-separated, at most 500) */
  vehicleIds?: string[]
}
export type ListCohortsResponse = /** status 200 OK */ VehicleEfficiencyCohortModel[]
export type ListCohortsArgs = {
  cohortType?: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  cohortId?: string
}
export type ListChargeModelsResponse = /** status 200 OK */ PagedResponseV2VehicleChargeModelListItem
export type ListChargeModelsArgs = {
  /** Sort order; only capabilitySetId */
  orderBy?: string
  /** Keyset cursor: only rows whose capabilitySetId is greater than this */
  afterCapabilitySetId?: string
  /** Rows per call, at most 500 */
  count?: number
}
export type GetUsagePlansByOrganizationIdResponse = /** status 200 OK */ UsagePlan[]
export type GetUsagePlansByOrganizationIdArgs = {
  id: string
}
export type GetApiKeyUsageByOrganizationIdResponse = /** status 200 OK */ ApiKeyUsage
export type GetApiKeyUsageByOrganizationIdArgs = {
  id: string
  keyId: string
  startDate?: string
  endDate?: string
}
export type GetApiKeySummariesByOrganizationIdResponse = /** status 200 OK */ OrganizationApiKeySummary[]
export type GetApiKeySummariesByOrganizationIdArgs = {
  id: string
}
export type DeleteSignatureResponse = unknown
export type DeleteSignatureArgs = {
  id: string
  signatureId: string
}
export type CapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetResponse =
  /** status 200 Successful Response */ ChargeCurveOut
export type CapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetArgs = {
  capabilitySetId: string
  /** The class of charger the vehicle is behind; default the most revealing learned curve */
  chargerClass?: ChargerClassParam | null
  direction?: Direction
}
export type RefitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPostResponse =
  /** status 200 Successful Response */ ChargeRefitOut
export type RefitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPostArgs = {
  capabilitySetId: string
  /** Read and fit, and answer the row that would be written; write nothing */
  dryRun?: boolean
}
export type CapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetResponse =
  /** status 200 Successful Response */ ChargeModelOut
export type CapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetArgs = {
  capabilitySetId: string
}
export type EstimateEnergyV1EnergyEstimatesPostResponse = /** status 200 Successful Response */ EnergyEstimateOut
export type EstimateEnergyV1EnergyEstimatesPostArgs = {
  energyEstimateIn: EnergyEstimateIn
}
export type FitChargeCurvesV1FitsChargeCurvesPostResponse = /** status 200 Successful Response */ ChargeRefitBulkOut
export type FitChargeCurvesV1FitsChargeCurvesPostArgs = {
  chargeCurveFitIn: ChargeCurveFitIn
}
export type FitEfficiencyV1FitsEfficiencyPostResponse = /** status 200 Successful Response */ EfficiencyRefitOut
export type FitEfficiencyV1FitsEfficiencyPostArgs = {
  efficiencyFitIn: EfficiencyFitIn
}
export type LatestFitRunV1FitsRunsLatestGetResponse = /** status 200 Successful Response */ FitRunsLatestOut
export type LatestFitRunV1FitsRunsLatestGetArgs = void
export type HealthV1HealthGetResponse = /** status 200 Successful Response */ HealthResponse
export type HealthV1HealthGetArgs = void
export type ListPlacesV1PlacesGetResponse = /** status 200 Successful Response */ PlaceListOut
export type ListPlacesV1PlacesGetArgs = {
  /** Only places of this kind */
  kind?: string | null
  /** Only the place of this site */
  siteId?: string | null
  /** Items per page (default 100, at most 500) */
  limit?: number | null
  /** `nextCursor` of the previous page: an opaque signed token. One that is altered, from another request, or issued before a key rotation or restart is `400 cursor_invalid`; restart paging from the first page */
  cursor?: string | null
}
export type GetPlaceV1PlacesPlaceIdGetResponse = /** status 200 Successful Response */ PlaceOut
export type GetPlaceV1PlacesPlaceIdGetArgs = {
  placeId: string
}
export type ListPlaceVisitsV1PlacesPlaceIdVisitsGetResponse = /** status 200 Successful Response */ VisitListOut
export type ListPlaceVisitsV1PlacesPlaceIdVisitsGetArgs = {
  placeId: string
  /** Start of the window (ISO-8601, inclusive); default 31 days before `to` */
  from?: string | null
  /** End of the window (exclusive); default now */
  to?: string | null
  /** Items per page (default 100, at most 500) */
  limit?: number | null
  /** `nextCursor` of the previous page: an opaque signed token. One that is altered, from another request, or issued before a key rotation or restart is `400 cursor_invalid`; restart paging from the first page */
  cursor?: string | null
}
export type ListPlanEvaluationsV1PlansEvaluationsGetResponse =
  /** status 200 Successful Response */ PlanEvaluationListOut
export type ListPlanEvaluationsV1PlansEvaluationsGetArgs = {
  /** First date; default 6 days before `to` */
  from?: string | null
  /** Last date, inclusive; default today; at most 31 days */
  to?: string | null
}
export type GetPlanEvaluationV1PlansEvaluationsDayGetResponse = /** status 200 Successful Response */ PlanEvaluationOut
export type GetPlanEvaluationV1PlansEvaluationsDayGetArgs = {
  /** The evaluation date (YYYY-MM-DD) */
  day: string
}
export type GetPlansEnvironmentHealthV1PlansHealthGetResponse =
  /** status 200 Successful Response */ PlansEnvironmentHealthOut
export type GetPlansEnvironmentHealthV1PlansHealthGetArgs = void
export type ComparePlansV1PlansSitesSiteIdCompareGetResponse = /** status 200 Successful Response */ PlanCompareOut
export type ComparePlansV1PlansSitesSiteIdCompareGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** Two to six plan ids, comma-separated; the first is the baseline */
  planIds: string
}
export type GetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetResponse =
  /** status 200 Successful Response */ PlanVersionOut
export type GetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** The service date (YYYY-MM-DD) in the site's time zone */
  serviceDate: string
}
export type GetPlansSiteHealthV1PlansSitesSiteIdHealthGetResponse =
  /** status 200 Successful Response */ PlansSiteHealthOut
export type GetPlansSiteHealthV1PlansSitesSiteIdHealthGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
}
export type ListPlanModelsV1PlansSitesSiteIdModelsGetResponse = /** status 200 Successful Response */ ModelHealthOut
export type ListPlanModelsV1PlansSitesSiteIdModelsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  capability?: ('departure_time' | 'energy_need' | 'arrival_soc' | 'charge_power' | 'vehicle_state') | null
  provider?: string | null
  windowDays?: number
}
export type ListPlanOutcomesV1PlansSitesSiteIdOutcomesGetResponse = /** status 200 Successful Response */ OutcomePageOut
export type ListPlanOutcomesV1PlansSitesSiteIdOutcomesGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** First date (UTC); default 6 days before `to` */
  from?: string | null
  /** Last date, inclusive; default today; at most 31 days */
  to?: string | null
  /** Rows per page, 1 to the service's maximum (default 20) */
  pageSize?: number | null
  /** The `nextCursor` of the previous page */
  cursor?: string | null
}
export type ListPlanVersionsV1PlansSitesSiteIdVersionsGetResponse =
  /** status 200 Successful Response */ PlanVersionPageOut
export type ListPlanVersionsV1PlansSitesSiteIdVersionsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** One local day (YYYY-MM-DD) in `timeZone`; not with `from` or `to` */
  date?: string | null
  /** IANA time zone of `date`; default UTC */
  timeZone?: string | null
  /** Start of the window (ISO-8601 instant); default 24 hours before `to` */
  from?: string | null
  /** End of the window (exclusive); default now; at most 7 days after `from` */
  to?: string | null
  /** Comma list of HEARTBEAT, EVENT, DAY_AHEAD, PREVIEW (staff only); default HEARTBEAT,EVENT */
  kind?: string | null
  /** Rows per page, 1 to the service's maximum (default 20) */
  pageSize?: number | null
  /** The `nextCursor` of the previous page */
  cursor?: string | null
}
export type GetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetResponse =
  /** status 200 Successful Response */ PlanVersionOut
export type GetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
}
export type DiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetResponse =
  /** status 200 Successful Response */ PlanDiffBodyOut
export type DiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  /** The plan to compare against; default the plan's parent */
  from?: string | null
}
export type ExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetResponse =
  /** status 200 Successful Response */ PlanExplainOut
export type ExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  /** What to explain; default the plan */
  subjectType?: 'plan' | 'vehicle' | 'route' | 'option' | 'diff' | 'override'
  /** Required for every subject but the plan */
  subjectId?: string | null
  /** Narrows the binding constraints shown */
  aspect?: 'cost' | 'carbon' | 'risk' | 'target' | 'yard' | 'all'
}
export type ListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetResponse =
  /** status 200 Successful Response */ ForecastListOut
export type ListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  subjectType?: ('route' | 'vehicle' | 'site') | null
  subjectId?: string | null
  quantity?:
    | (
        | 'departure_time'
        | 'arrival_time'
        | 'ready_time'
        | 'arrival_soc'
        | 'energy_need'
        | 'charge_power'
        | 'price'
        | 'carbon'
      )
    | null
}
export type ListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetResponse =
  /** status 200 Successful Response */ PlanOptionsOut
export type ListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  /** route, vehicle or site; with subjectId */
  subjectType?: ('route' | 'vehicle' | 'site') | null
  /** With subjectType */
  subjectId?: string | null
  /** Only options relaxing this constraint */
  family?:
    | ('departure_time' | 'charger_assignment' | 'target_soc' | 'priority' | 'carbon_weight' | 'dock_vs_yard')
    | null
}
export type GetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetResponse =
  /** status 200 Successful Response */ OptionOut
export type GetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  optionId: string
}
export type GetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetResponse =
  /** status 200 Successful Response */ PlanTimelineOut
export type GetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  /** `slots` adds the per-slot site power, price and carbon */
  include?: 'slots' | null
}
export type ListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetResponse =
  /** status 200 Successful Response */ VerdictListOut
export type ListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetArgs = {
  /** The site (chargers-api depot) id: 32 lowercase hexadecimal characters */
  siteId: string
  /** A plan id (`pl_` and 26 characters) or `current`, the newest heartbeat or event plan */
  planId: string
  /** Only this route */
  routeId?: string | null
  /** Only this verdict */
  verdict?: ('feasible' | 'watch' | 'infeasible' | 'needsVehicle') | null
}
export type EvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetResponse =
  /** status 200 Successful Response */ SiteEvaluationOut
export type EvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetArgs = {
  siteId: string
  /** Start of the window (ISO-8601); default now */
  from?: string | null
  /** End of the window (exclusive); default 72 hours after from, at most 192 hours */
  to?: string | null
  /** hour: one point per hour; block: the fitter's UTC-aligned blocks */
  resolution?: Resolution
}
export type SiteVisitsDayV1SitesSiteIdVisitsDaysDateGetResponse = /** status 200 Successful Response */ SiteDayOut
export type SiteVisitsDayV1SitesSiteIdVisitsDaysDateGetArgs = {
  siteId: string
  date: string
}
export type VehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetResponse =
  /** status 200 Successful Response */ ChargeCurveOut
export type VehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetArgs = {
  vehicleId: string
  /** The class of charger the vehicle is behind; default the most revealing learned curve */
  chargerClass?: ChargerClassParam | null
  direction?: Direction
}
export type VehicleChargeDurationV1VehiclesVehicleIdChargeDurationPostResponse =
  /** status 200 Successful Response */ ChargeDurationOut
export type VehicleChargeDurationV1VehiclesVehicleIdChargeDurationPostArgs = {
  vehicleId: string
  chargeDurationIn: ChargeDurationIn
}
export type GetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetResponse =
  /** status 200 Successful Response */ EfficiencyModelOut
export type GetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetArgs = {
  vehicleId: string
}
export type RebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPostResponse =
  /** status 202 Successful Response */ RebuildQueuedOut
export type RebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPostArgs = {
  vehicleId: string
}
export type RefitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPostResponse =
  /** status 200 Successful Response */ EfficiencyModelOut
export type RefitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPostArgs = {
  vehicleId: string
  /** Read and fit, and answer the row that would be written; write nothing */
  dryRun?: boolean
  /** Fit at this instant instead of now (ISO-8601); only with dryRun=true, else 400 as_of_requires_dry_run */
  asOf?: string | null
}
export type EvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetResponse =
  /** status 200 Successful Response */ EvaluationOut
export type EvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetArgs = {
  vehicleId: string
  /** Start of the window (ISO-8601); default now */
  from?: string | null
  /** End of the window (exclusive); default 72 hours after from, at most 192 hours */
  to?: string | null
  /** The departure site whose forecast is used; default the vehicle's home site */
  siteId?: string | null
  /** hour: one point per hour; block: the fitter's UTC-aligned blocks */
  resolution?: Resolution
}
export type EfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetResponse =
  /** status 200 Successful Response */ HistoryOut
export type EfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetArgs = {
  vehicleId: string
  /** Start of the range (ISO-8601 instant); default 365 days before to */
  from?: string | null
  /** End of the range (exclusive); default now */
  to?: string | null
  /** WEEK (Monday 00:00 local) or MONTH (the 1st, 00:00 local) */
  bucket?: HistoryBucketSize
  /** IANA time zone the bucket boundaries are computed in; default UTC */
  timeZone?: string | null
}
export type ResetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPostResponse =
  /** status 200 Successful Response */ EfficiencyModelOut
export type ResetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPostArgs = {
  vehicleId: string
  resetIn: ResetIn
}
export type EfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetResponse =
  /** status 200 Successful Response */ BlockSamplesOut
export type EfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetArgs = {
  vehicleId: string
  /** The sample kind; BLOCK is the only one served from the state */
  kind?: SampleKindParam
  /** Blocks starting at or after this instant */
  from?: string | null
  /** Blocks starting before this instant */
  to?: string | null
  /** Zero-based page */
  page?: number
  /** Blocks per page */
  pageSize?: number
}
export type GetStateForecastV1VehiclesVehicleIdStateForecastGetResponse =
  /** status 200 Successful Response */ StateForecastOut
export type GetStateForecastV1VehiclesVehicleIdStateForecastGetArgs = {
  vehicleId: string
  /** Start of the window (ISO-8601); default now, never before `dataThrough`; a `from` before `dataThrough` is 422 */
  from?: string | null
  /** End of the window (exclusive); default 24 hours after `from`, at most the end of the forecast's last slot (`dataThrough` floored to 15 minutes, plus 72 hours) */
  to?: string | null
  /** 15m: one entry per UTC 15-minute slot; hour: one per UTC clock hour (the mean of its slots) */
  resolution?: StateForecastResolution
  /** Comma-separated: `slots`, `events`; default both. What is not included is absent */
  include?: string | null
}
export type ListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetResponse =
  /** status 200 Successful Response */ VisitEventListOut
export type ListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetArgs = {
  vehicleId: string
  /** Start of the window (ISO-8601, inclusive); default 31 days before `to` */
  from?: string | null
  /** End of the window (exclusive); default now */
  to?: string | null
  /** Items per page (default 100, at most 500) */
  limit?: number | null
  /** `nextCursor` of the previous page: an opaque signed token. One that is altered, from another request, or issued before a key rotation or restart is `400 cursor_invalid`; restart paging from the first page */
  cursor?: string | null
}
export type ListVehicleVisitsV1VehiclesVehicleIdVisitsGetResponse = /** status 200 Successful Response */ VisitListOut
export type ListVehicleVisitsV1VehiclesVehicleIdVisitsGetArgs = {
  vehicleId: string
  /** Start of the window (ISO-8601, inclusive); default 31 days before `to` */
  from?: string | null
  /** End of the window (exclusive); default now */
  to?: string | null
  /** SITE_GEOFENCE, LOI_POLYGON, LOI_POINT_RADIUS, PIN_RADIUS or INFERRED_DEPOT */
  placeKind?: string | null
  /** `site.<id>`, `loi.<id>`, `pin.<id>` or `depot.<id>` */
  placeId?: string | null
  /** Only visits still open */
  openOnly?: boolean
  /** Items per page (default 100, at most 500) */
  limit?: number | null
  /** `nextCursor` of the previous page: an opaque signed token. One that is altered, from another request, or issued before a key rotation or restart is `400 cursor_invalid`; restart paging from the first page */
  cursor?: string | null
}
export type VehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetResponse =
  /** status 200 Successful Response */ VisitSummaryOut
export type VehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetArgs = {
  vehicleId: string
  /** Start of the window (ISO-8601, inclusive); default 31 days before `to` */
  from?: string | null
  /** End of the window (exclusive); default now */
  to?: string | null
  /** IANA zone of the days (default UTC) */
  timeZone?: string | null
}
export type ListOpenVisitsV1VisitsOpenGetResponse = /** status 200 Successful Response */ VisitListOut
export type ListOpenVisitsV1VisitsOpenGetArgs = {
  /** Only visits at this place */
  placeId?: string | null
  /** Only places of this kind */
  placeKind?: string | null
  /** Items per page (default 100, at most 500) */
  limit?: number | null
  /** `nextCursor` of the previous page: an opaque signed token. One that is altered, from another request, or issued before a key rotation or restart is `400 cursor_invalid`; restart paging from the first page */
  cursor?: string | null
}
export type VehicleEfficiencyCurvePoint = {
  /** Ambient temperature in degrees C */
  temperature: number
  /** Dimensionless multiplier applied to the baseline efficiency (1.0 = baseline) */
  multiplier: number
}
export type VehicleEfficiencyWeatherBin = {
  /** Inclusive lower edge of the bin in degrees C */
  binStart: number
  /** Exclusive upper edge of the bin in degrees C */
  binEnd: number
  /** Samples of the vehicle that fell in the bin */
  sampleCount: number
  /** Median multiplier of the bin's samples against the vehicle's baseline (1.0 = baseline) */
  medianMultiplier?: number
  /** Median efficiency of the bin's samples in kWh/km */
  medianEfficiency?: number
}
export type VehicleEfficiencyModel = {
  /** Vehicle id */
  vehicleId?: string
  /** COLLECTING (cohort curve), TRAINED (own curve) or STALE (own curve not refitted recently) */
  status?: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** Which curve is in use; VEHICLE means the vehicle's own, PRIOR the fixed prior curve (no own bins and no cohort; confidence is null) */
  fallbackLevel?: 'VEHICLE' | 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL' | 'PRIOR'
  /** Cohort the curve in use was pooled over, when not the vehicle's own */
  cohortType?: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  /** Id of that cohort */
  cohortId?: string
  /** Samples the vehicle's own fit was based on */
  sampleCount?: number
  /** Coldest ambient temperature observed in the vehicle's samples, degrees C */
  minTemperature?: number
  /** Warmest ambient temperature observed in the vehicle's samples, degrees C */
  maxTemperature?: number
  /** Efficiency at reference conditions in kWh/km */
  baselineEfficiency?: number
  /** Where the baseline came from */
  baselineSource?: 'VEHICLE' | 'CAPABILITY_SET' | 'COHORT' | 'OWN_MEDIAN' | 'COHORT_MEDIAN'
  /** Temperature-vs-multiplier points of the curve in use, ordered by temperature */
  weatherPoints?: VehicleEfficiencyCurvePoint[]
  /** The vehicle's raw per-bin statistics from its own samples (5 degree C bins), ordered by binStart; pooled by the cohort job */
  weatherBins?: VehicleEfficiencyWeatherBin[]
  /** Fractional efficiency change per kg of payload, 1/kg: the payload multiplier is 1 + payloadSlope x (payload - typicalPayload) */
  payloadSlope?: number
  /** Samples with a known payload the slope was fit on */
  payloadSampleCount?: number
  /** Median payload in kg of the samples the slope was fit on; the predictor's payload input for trips without a route weight */
  typicalPayload?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Median absolute residual of the fit in kWh/km */
  residualMad?: number
  /** P75 of the in-sample ratio actual/modelled energy, clamped to 1.0..1.5: the safety margin energy-api multiplies into a requirement; dimensionless */
  residualP75?: number
  /** Predictor model name */
  modelName?: string
  /** Predictor model version */
  modelVersion?: string
  /** When the vehicle's own curve was last fit; null until it has been */
  lastFittedAt?: string
  /** Server-owned, set by a reset: samples before this instant are ignored by the predictor; null when the model has never been reset */
  trainingFrom?: string
  /** Server-owned: when the model was last reset; null when it never has been */
  resetAt?: string
  /** Server-owned: user id (or API key name) that requested the last reset */
  resetBy?: string
  /** Server-owned: reason given for the last reset */
  resetReason?: string
  /** Server-owned: how many times the model has been reset */
  resetCount?: number
  /** When the row was created */
  created?: string
  /** When the row was last updated */
  updated?: string
}
export type VehicleEfficiencyModelParams = {
  /** COLLECTING (cohort curve), TRAINED (own curve) or STALE (own curve not refitted recently) */
  status: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** Which curve is in use; VEHICLE means the vehicle's own, PRIOR the fixed prior curve (no own bins and no cohort; confidence is null) */
  fallbackLevel: 'VEHICLE' | 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL' | 'PRIOR'
  /** Cohort the curve in use was pooled over, when not the vehicle's own */
  cohortType?: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  /** Id of that cohort */
  cohortId?: string
  /** Samples the vehicle's own fit was based on */
  sampleCount?: number
  /** Coldest ambient temperature observed in the vehicle's samples, degrees C */
  minTemperature?: number
  /** Warmest ambient temperature observed in the vehicle's samples, degrees C */
  maxTemperature?: number
  /** Efficiency at reference conditions in kWh/km */
  baselineEfficiency?: number
  /** Where the baseline came from */
  baselineSource?: 'VEHICLE' | 'CAPABILITY_SET' | 'COHORT' | 'OWN_MEDIAN' | 'COHORT_MEDIAN'
  /** Temperature-vs-multiplier points of the curve in use, ordered by temperature */
  weatherPoints?: VehicleEfficiencyCurvePoint[]
  /** The vehicle's raw per-bin statistics from its own samples (5 degree C bins), ordered by binStart; pooled by the cohort job */
  weatherBins?: VehicleEfficiencyWeatherBin[]
  /** Fractional efficiency change per kg of payload, 1/kg: the payload multiplier is 1 + payloadSlope x (payload - typicalPayload) */
  payloadSlope?: number
  /** Samples with a known payload the slope was fit on */
  payloadSampleCount?: number
  /** Median payload in kg of the samples the slope was fit on; the predictor's payload input for trips without a route weight */
  typicalPayload?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Median absolute residual of the fit in kWh/km */
  residualMad?: number
  /** P75 of the in-sample ratio actual/modelled energy, clamped to 1.0..1.5: the safety margin energy-api multiplies into a requirement; dimensionless */
  residualP75?: number
  /** Predictor model name */
  modelName: string
  /** Predictor model version */
  modelVersion: string
  /** When the vehicle's own curve was last fit; null until it has been */
  lastFittedAt?: string
}
export type VehicleCatalogWmi = {
  /** Three-character WMI */
  wmi?: string
  /** Catalog manufacturer id */
  manufacturerId?: string
  /** Manufacturer display name */
  manufacturerName?: string
  /** Where this mapping came from */
  source?: 'SEEDED' | 'ADMIN' | 'USER' | 'BACKFILL'
}
export type VehicleCatalogWmiParams = {
  /** Three-character WMI */
  wmi: string
  /** Catalog manufacturer id */
  manufacturerId: string
}
export type VehicleCatalogPowerCurvePoint = {
  /** State of charge in percent */
  socPercent: number
  /** Maximum power at this SOC (kW) */
  maxPower: number
}
export type VehicleCatalogPowerCurveSourceRegion = {
  /** Inclusive lower bound of the region, state of charge in percent */
  from: number
  /** Inclusive upper bound of the region, state of charge in percent */
  to: number
  /** How the points inside the region were obtained */
  source: 'MEASURED' | 'COHORT' | 'LOWER_BOUND'
}
export type VehicleCatalogPowerCurve = {
  /** Power curve id */
  id?: string
  /** Capability set the curve belongs to */
  capabilitySetId?: string
  /** CHARGE or DISCHARGE */
  direction?: 'CHARGE' | 'DISCHARGE'
  /** Where the curve came from */
  source?: 'OEM_SPEC' | 'AUTHORED' | 'LEARNED'
  /** Charger class a LEARNED curve was observed on; one active LEARNED curve per class. Null on OEM_SPEC and AUTHORED curves */
  chargerClass?: 'AC_7' | 'AC_22' | 'AC_HIGH' | 'DC_50' | 'DC_150' | 'DC_HIGH'
  /** Points ordered by SOC from 0 to 100; power in kW */
  points?: VehicleCatalogPowerCurvePoint[]
  /** How to interpolate between points */
  interpolation?: 'LINEAR' | 'STEP'
  /** When a LEARNED curve was last fit */
  fittedAt?: string
  /** Sessions a LEARNED curve was fit on */
  sessionCount?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Model version that produced a LEARNED curve */
  modelVersion?: string
  /** Lowest state of charge a LEARNED curve was measured at, percent; the curve below it is cohort-seeded or a lower bound */
  socCoverageFrom?: number
  /** Highest state of charge a LEARNED curve was measured at, percent; the curve above it is cohort-seeded or a lower bound */
  socCoverageTo?: number
  /** Share of a LEARNED curve's samples that were censored by the charger or connector, 0..1 */
  censoredShare?: number
  /** Provenance of a LEARNED curve by state-of-charge region, ordered by from: measured, cohort-seeded or lower bound */
  curveSourceRegions?: VehicleCatalogPowerCurveSourceRegion[]
  /** Whether the curve is in effect */
  active?: boolean
}
export type JsonNullablePowerCurveSource = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullablePowerCurveInterpolation = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullableBoolean = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullableListVehicleCatalogPowerCurvePoint = {
  present?: boolean
  undefined?: boolean
}
export type VehicleCatalogPowerCurveUpdateParams = {
  /** Where the curve came from; defaults to AUTHORED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  source?: JsonNullablePowerCurveSource
  /** How to interpolate between points; defaults to LINEAR on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  interpolation?: JsonNullablePowerCurveInterpolation
  /** Whether the curve is in effect; defaults to true on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  active?: JsonNullableBoolean
  /** Replacement points: at least two, SOC strictly increasing from 0 to 100, power (kW) >= 0. An explicit null is rejected on update; omit the field to keep the stored value. */
  points?: JsonNullableListVehicleCatalogPowerCurvePoint
}
export type VehicleCatalogPowerCurveFitParams = {
  /** Capability set the curve belongs to */
  capabilitySetId: string
  /** CHARGE or DISCHARGE */
  direction: 'CHARGE' | 'DISCHARGE'
  /** Charger class the curve was observed on; one active LEARNED curve per class */
  chargerClass: 'AC_7' | 'AC_22' | 'AC_HIGH' | 'DC_50' | 'DC_150' | 'DC_HIGH'
  /** At least two points, SOC strictly increasing from 0 to 100, power (kW) >= 0 */
  points: VehicleCatalogPowerCurvePoint[]
  /** How to interpolate between points; LINEAR when absent */
  interpolation?: 'LINEAR' | 'STEP'
  /** When the curve was fit */
  fittedAt: string
  /** Sessions the curve was fit on */
  sessionCount: number
  /** Fit confidence 0..1 */
  confidence: number
  /** Model version that produced the curve */
  modelVersion: string
  /** Lowest state of charge covered by the set's own uncensored samples, percent */
  socCoverageFrom?: number
  /** Highest state of charge covered by the set's own uncensored samples, percent */
  socCoverageTo?: number
  /** Share of the fitted samples that were censored by the charger or connector, 0..1 */
  censoredShare?: number
  /** Provenance of the curve by state-of-charge region, ordered by from; measured regions are the set's own, cohort regions borrow the cohort shape, lower-bound regions are flat */
  curveSourceRegions?: VehicleCatalogPowerCurveSourceRegion[]
}
export type VehicleCatalogManufacturer = {
  /** Catalog manufacturer id */
  id?: string
  /** Display name */
  name?: string
  /** Normalized name used for matching free-text makes (lowercase, alphanumerics only) */
  normalizedName?: string
  /** Logo URL */
  logoUrl?: string
  /** ISO 3166-1 alpha-2 country of the manufacturer */
  countryCode?: string
  /** Verification status of this catalog entry */
  verificationStatus?: 'PROPOSED' | 'VERIFIED' | 'REJECTED' | 'MERGED'
  /** Organization that proposed this entry, when it was contributed by a customer */
  contributedByOrganizationId?: string
  /** User that proposed this entry, when it was contributed by a customer */
  contributedByUserId?: string
  /** When status is MERGED, the manufacturer this one was merged into */
  mergedIntoId?: string
}
export type JsonNullableString = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullableVehicleCatalogVerificationStatus = {
  present?: boolean
  undefined?: boolean
}
export type VehicleCatalogManufacturerUpdateParams = {
  /** Logo URL */
  logoUrl?: JsonNullableString
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: JsonNullableString
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
  /** Display name; renames the manufacturer when present. An explicit null is rejected on update; omit the field to keep the stored value. */
  name?: JsonNullableString
}
export type VehicleCatalogMakeModel = {
  /** Catalog make-model id */
  id?: string
  /** Catalog manufacturer id */
  manufacturerId?: string
  /** Manufacturer display name */
  manufacturerName?: string
  /** Model display name */
  name?: string
  /** Normalized model name used for matching free-text models */
  normalizedName?: string
  /** Free-text guidance shown next to the model in pickers */
  modelHelperText?: string
  /** Vehicle type */
  vehicleType?: string
  /** GVWR-style vehicle class (1-8) */
  vehicleClass?: number
  /** Capability set applied to vehicles of this model unless a version matches their model year */
  defaultCapabilitySetId?: string
  /** Whether the model is offered in customer-facing pickers */
  published?: boolean
  /** Verification status of this catalog entry */
  verificationStatus?: 'PROPOSED' | 'VERIFIED' | 'REJECTED' | 'MERGED'
  /** Organization that proposed this entry, when it was contributed by a customer */
  contributedByOrganizationId?: string
  /** User that proposed this entry, when it was contributed by a customer */
  contributedByUserId?: string
  /** When status is MERGED, the make-model this one was merged into */
  mergedIntoId?: string
}
export type JsonNullableInteger = {
  present?: boolean
  undefined?: boolean
}
export type VehicleCatalogMakeModelUpdateParams = {
  /** Free-text guidance shown next to the model in pickers */
  modelHelperText?: JsonNullableString
  /** Vehicle type */
  vehicleType?: JsonNullableString
  /** GVWR-style vehicle class (1-8) */
  vehicleClass?: JsonNullableInteger
  /** Capability set applied to vehicles of this model unless a version matches their model year */
  defaultCapabilitySetId?: JsonNullableString
  /** Whether the model is offered in customer-facing pickers; defaults to true on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  published?: JsonNullableBoolean
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
  /** Model display name; renames the model when present. An explicit null is rejected on update; omit the field to keep the stored value. */
  name?: JsonNullableString
}
export type VehicleCatalogCapabilitySet = {
  /** Capability set id */
  id?: string
  /** Catalog make-model id this set belongs to */
  makeModelId?: string
  /** Version, unique per make-model */
  version?: number
  /** Whether this version may be assigned to vehicles */
  published?: boolean
  /** Free-text notes */
  notes?: string
  /** Trim / configuration this set describes, e.g. battery size variant */
  variantName?: string
  /** First model year this set applies to (inclusive) */
  modelYearFrom?: number
  /** Last model year this set applies to (inclusive) */
  modelYearTo?: number
  /** Smallest nameplate battery size this set applies to (kWh, inclusive); null does not constrain */
  batterySizeMin?: number
  /** Largest nameplate battery size this set applies to (kWh, inclusive); null does not constrain */
  batterySizeMax?: number
  /** Whether the vehicle can discharge to the grid or site (V2G/V2B) */
  isDischargeCapable?: boolean
  /** Whether discharge charging profiles must be sent in current (A) rather than power (W) */
  needsCurrentInProfilesForDischarge?: boolean
  /** SOC percentage the vehicle must not be discharged below */
  socDischargeFloorPercent?: number
  /** Nameplate battery size (kWh) */
  batterySize?: number
  /** Usable battery capacity (kWh) */
  usableBattery?: number
  /** OEM-rated range (km) */
  estimatedRange?: number
  /** OEM-rated efficiency (kWh/km) */
  baselineEfficiency?: number
  /** Maximum charge power (kW); flat cap, see power curves for SOC dependence */
  maxChargePower?: number
  /** Maximum discharge power (kW) */
  maxDischargePower?: number
  /** Free-form long-tail quirks */
  knownQuirks?: {
    [key: string]: object
  }
  /** Verification status of this catalog entry */
  verificationStatus?: 'PROPOSED' | 'VERIFIED' | 'REJECTED' | 'MERGED'
  /** Organization that proposed this entry, when it was contributed by a customer */
  contributedByOrganizationId?: string
  /** User that proposed this entry, when it was contributed by a customer */
  contributedByUserId?: string
  /** When status is MERGED, the capability set this one was merged into */
  mergedIntoId?: string
}
export type JsonNullableBigDecimal = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullableMapStringObject = {
  present?: boolean
  undefined?: boolean
}
export type VehicleCatalogCapabilitySetUpdateParams = {
  /** Whether this version may be assigned to vehicles; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  published?: JsonNullableBoolean
  /** Free-text notes */
  notes?: JsonNullableString
  /** Trim / configuration this set describes */
  variantName?: JsonNullableString
  /** First model year this set applies to (inclusive) */
  modelYearFrom?: JsonNullableInteger
  /** Last model year this set applies to (inclusive) */
  modelYearTo?: JsonNullableInteger
  /** Smallest nameplate battery size this set applies to (kWh, inclusive). Together with batterySizeMax it lets VIN decode matching pick this set for a vehicle whose decoded battery size falls inside the range; must not exceed batterySizeMax. */
  batterySizeMin?: JsonNullableBigDecimal
  /** Largest nameplate battery size this set applies to (kWh, inclusive) */
  batterySizeMax?: JsonNullableBigDecimal
  /** Whether the vehicle can discharge to the grid or site; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  isDischargeCapable?: JsonNullableBoolean
  /** Whether discharge profiles must be sent in current rather than power; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  needsCurrentInProfilesForDischarge?: JsonNullableBoolean
  /** SOC percentage the vehicle must not be discharged below */
  socDischargeFloorPercent?: JsonNullableInteger
  /** Nameplate battery size (kWh) */
  batterySize?: JsonNullableBigDecimal
  /** Usable battery capacity (kWh) */
  usableBattery?: JsonNullableBigDecimal
  /** OEM-rated range (km) */
  estimatedRange?: JsonNullableBigDecimal
  /** OEM-rated efficiency (kWh/km) */
  baselineEfficiency?: JsonNullableBigDecimal
  /** Maximum charge power (kW); flat cap, see power curves for SOC dependence */
  maxChargePower?: JsonNullableBigDecimal
  /** Maximum discharge power (kW) */
  maxDischargePower?: JsonNullableBigDecimal
  /** Free-form long-tail quirks */
  knownQuirks?: JsonNullableMapStringObject
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
}
export type VehicleEfficiencyCohortModel = {
  /** Grouping the curve was pooled over */
  cohortType?: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
  /** Capability set id, make-model id, organization id, site id or "global" depending on cohortType */
  cohortId?: string
  /** Display label for the cohort */
  label?: string
  /** Vehicles that contributed samples to the fit */
  vehicleCount?: number
  /** Samples the fit was based on */
  sampleCount?: number
  /** Coldest ambient temperature observed in the cohort's samples, degrees C */
  minTemperature?: number
  /** Warmest ambient temperature observed in the cohort's samples, degrees C */
  maxTemperature?: number
  /** Temperature-vs-multiplier points of the curve, ordered by temperature */
  weatherPoints?: VehicleEfficiencyCurvePoint[]
  /** Fractional efficiency change per kg of payload, 1/kg: the payload multiplier is 1 + payloadSlope x (payload - typicalPayload) */
  payloadSlope?: number
  /** P75 of the in-sample ratio actual/modelled energy over the cohort's trips, clamped to 1.0..1.5: the safety margin served to fallback vehicles; dimensionless */
  residualP75?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Predictor model name */
  modelName?: string
  /** Predictor model version */
  modelVersion?: string
  /** When the curve was last fit */
  lastFittedAt?: string
  /** When the row was created */
  created?: string
  /** When the row was last updated */
  updated?: string
}
export type VehicleEfficiencyCohortModelParams = {
  /** Display label for the cohort */
  label?: string
  /** Vehicles that contributed samples to the fit */
  vehicleCount?: number
  /** Samples the fit was based on */
  sampleCount?: number
  /** Coldest ambient temperature observed in the cohort's samples, degrees C */
  minTemperature?: number
  /** Warmest ambient temperature observed in the cohort's samples, degrees C */
  maxTemperature?: number
  /** Temperature-vs-multiplier points of the curve, ordered by temperature */
  weatherPoints?: VehicleEfficiencyCurvePoint[]
  /** Fractional efficiency change per kg of payload, 1/kg: the payload multiplier is 1 + payloadSlope x (payload - typicalPayload) */
  payloadSlope?: number
  /** P75 of the in-sample ratio actual/modelled energy over the cohort's trips, clamped to 1.0..1.5: the safety margin served to fallback vehicles; dimensionless */
  residualP75?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Predictor model name */
  modelName: string
  /** Predictor model version */
  modelVersion: string
  /** When the curve was last fit */
  lastFittedAt?: string
}
export type VehicleChargeModel = {
  /** Capability set the model belongs to */
  capabilitySetId?: string
  /** COLLECTING (no confident learned curve yet), TRAINED (own learned curve) or STALE */
  status?: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** Which curve the set resolves to; PRIOR is the catalog's OEM_SPEC or AUTHORED curve while nothing has been learned */
  fallbackLevel?: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'GLOBAL' | 'PRIOR'
  /** Charging sessions of the set's vehicles that the last fit pooled */
  sessionCount?: number
  /** Distinct vehicles those sessions came from */
  vehicleCount?: number
  /** Lowest state of charge covered by the set's own uncensored samples, percent */
  socCoverageFrom?: number
  /** Highest state of charge covered by the set's own uncensored samples, percent */
  socCoverageTo?: number
  /** Share of the fitted samples that were censored by the charger or connector, 0..1 */
  censoredShare?: number
  /** State of charge at which the highest-class learned curve peaks and starts to taper, percent */
  kneeSoc?: number
  /** Grid-to-pack charging efficiency of the set: energy stored over energy metered at the charger, 0..1 */
  chargingEfficiency?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Median absolute percentage error of predicted charge durations on the held-out sessions, fraction */
  holdoutMedianApe?: number
  /** 90th percentile absolute percentage error of predicted charge durations on the held-out sessions, fraction */
  holdoutP90Ape?: number
  /** Mean of predicted minus actual charge duration on the held-out sessions in minutes; positive means over-forecast */
  holdoutBiasMinutes?: number
  /** Server-owned, set by a reset: sessions before this instant are ignored by the fitter; null when the model has never been reset */
  trainingFrom?: string
  /** Start of the newest session the last fit pooled */
  lastSessionAt?: string
  /** When the set's curves were last fit; null until they have been */
  lastFittedAt?: string
  /** Fitter model version */
  modelVersion?: string
  /** When the row was created */
  created?: string
  /** When the row was last updated */
  updated?: string
}
export type VehicleChargeModelFitParams = {
  /** COLLECTING (no confident learned curve yet), TRAINED (own learned curve) or STALE */
  status: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** Which curve the set resolves to; PRIOR is the catalog's OEM_SPEC or AUTHORED curve while nothing has been learned */
  fallbackLevel: 'CAPABILITY_SET' | 'MAKE_MODEL' | 'GLOBAL' | 'PRIOR'
  /** Charging sessions of the set's vehicles that the fit pooled */
  sessionCount: number
  /** Distinct vehicles those sessions came from */
  vehicleCount: number
  /** Lowest state of charge covered by the set's own uncensored samples, percent */
  socCoverageFrom?: number
  /** Highest state of charge covered by the set's own uncensored samples, percent */
  socCoverageTo?: number
  /** Share of the fitted samples that were censored by the charger or connector, 0..1 */
  censoredShare?: number
  /** State of charge at which the highest-class learned curve peaks and starts to taper, percent */
  kneeSoc?: number
  /** Grid-to-pack charging efficiency of the set: energy stored over energy metered at the charger, 0..1 */
  chargingEfficiency?: number
  /** Fit confidence 0..1 */
  confidence?: number
  /** Median absolute percentage error of predicted charge durations on the held-out sessions, fraction */
  holdoutMedianApe?: number
  /** 90th percentile absolute percentage error of predicted charge durations on the held-out sessions, fraction */
  holdoutP90Ape?: number
  /** Mean of predicted minus actual charge duration on the held-out sessions in minutes; positive means over-forecast */
  holdoutBiasMinutes?: number
  /** Start of the newest session the fit pooled */
  lastSessionAt?: string
  /** When the set's curves were last fit; null while still collecting */
  lastFittedAt?: string
  /** Fitter model version */
  modelVersion: string
}
export type VehicleEfficiencyModelResetParams = {
  /** Samples before this instant are ignored by the predictor from now on; defaults to now. The server rejects a value in the future or more than 3 years back. */
  trainingFrom?: string
  /** Free-text reason recorded on the model */
  resetReason?: string
}
export type VehicleCatalogProposal = {
  manufacturer?: VehicleCatalogManufacturer
  makeModel?: VehicleCatalogMakeModel
}
export type VehicleCatalogProposalParams = {
  /** Manufacturer name as the user typed it */
  manufacturerName: string
  /** Model name as the user typed it */
  modelName: string
}
export type VehicleCatalogPowerCurveCreateParams = {
  /** Where the curve came from; defaults to AUTHORED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  source?: JsonNullablePowerCurveSource
  /** How to interpolate between points; defaults to LINEAR on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  interpolation?: JsonNullablePowerCurveInterpolation
  /** Whether the curve is in effect; defaults to true on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  active?: JsonNullableBoolean
  /** Capability set the curve belongs to (immutable) */
  capabilitySetId: string
  /** CHARGE or DISCHARGE (immutable) */
  direction: 'CHARGE' | 'DISCHARGE'
  /** At least two points, SOC strictly increasing from 0 to 100, power (kW) >= 0 */
  points: VehicleCatalogPowerCurvePoint[]
}
export type VehicleCatalogManufacturerCreateParams = {
  /** Logo URL */
  logoUrl?: JsonNullableString
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: JsonNullableString
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
  /** Display name */
  name: string
}
export type VehicleCatalogMergeParams = {
  /** Id of the entry that survives */
  targetId: string
}
export type VehicleCatalogMakeModelCreateParams = {
  /** Free-text guidance shown next to the model in pickers */
  modelHelperText?: JsonNullableString
  /** Vehicle type */
  vehicleType?: JsonNullableString
  /** GVWR-style vehicle class (1-8) */
  vehicleClass?: JsonNullableInteger
  /** Capability set applied to vehicles of this model unless a version matches their model year */
  defaultCapabilitySetId?: JsonNullableString
  /** Whether the model is offered in customer-facing pickers; defaults to true on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  published?: JsonNullableBoolean
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
  /** Catalog manufacturer id (immutable) */
  manufacturerId: string
  /** Model display name */
  name: string
}
export type VehicleMakeModelSignature = {
  /** Signature id */
  id?: string
  /** Catalog make-model id this signature resolves to */
  makeModelId?: string
  /** Three-character WMI */
  wmi?: string
  /** Normalized vPIC Make */
  vpicMake?: string
  /** Normalized vPIC Model */
  vpicModel?: string
  /** Normalized vPIC Series */
  vpicSeries?: string
  /** Normalized vPIC BodyClass */
  bodyClass?: string
  /** Breaks ties between equally specific signatures; higher wins */
  priority?: number
  /** User that created the signature */
  createdBy?: string
}
export type VehicleMakeModelSignatureCreateParams = {
  /** Three-character WMI */
  wmi?: string
  /** vPIC Make */
  vpicMake?: string
  /** vPIC Model */
  vpicModel?: string
  /** vPIC Series */
  vpicSeries?: string
  /** vPIC BodyClass */
  bodyClass?: string
  /** Breaks ties between equally specific signatures; higher wins. Defaults to 0. */
  priority?: number
}
export type VehicleCatalogCapabilitySetCreateParams = {
  /** Whether this version may be assigned to vehicles; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  published?: JsonNullableBoolean
  /** Free-text notes */
  notes?: JsonNullableString
  /** Trim / configuration this set describes */
  variantName?: JsonNullableString
  /** First model year this set applies to (inclusive) */
  modelYearFrom?: JsonNullableInteger
  /** Last model year this set applies to (inclusive) */
  modelYearTo?: JsonNullableInteger
  /** Smallest nameplate battery size this set applies to (kWh, inclusive). Together with batterySizeMax it lets VIN decode matching pick this set for a vehicle whose decoded battery size falls inside the range; must not exceed batterySizeMax. */
  batterySizeMin?: JsonNullableBigDecimal
  /** Largest nameplate battery size this set applies to (kWh, inclusive) */
  batterySizeMax?: JsonNullableBigDecimal
  /** Whether the vehicle can discharge to the grid or site; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  isDischargeCapable?: JsonNullableBoolean
  /** Whether discharge profiles must be sent in current rather than power; defaults to false on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  needsCurrentInProfilesForDischarge?: JsonNullableBoolean
  /** SOC percentage the vehicle must not be discharged below */
  socDischargeFloorPercent?: JsonNullableInteger
  /** Nameplate battery size (kWh) */
  batterySize?: JsonNullableBigDecimal
  /** Usable battery capacity (kWh) */
  usableBattery?: JsonNullableBigDecimal
  /** OEM-rated range (km) */
  estimatedRange?: JsonNullableBigDecimal
  /** OEM-rated efficiency (kWh/km) */
  baselineEfficiency?: JsonNullableBigDecimal
  /** Maximum charge power (kW); flat cap, see power curves for SOC dependence */
  maxChargePower?: JsonNullableBigDecimal
  /** Maximum discharge power (kW) */
  maxDischargePower?: JsonNullableBigDecimal
  /** Free-form long-tail quirks */
  knownQuirks?: JsonNullableMapStringObject
  /** Verification status; defaults to VERIFIED on create. An explicit null is rejected on update; omit the field to keep the stored value. */
  verificationStatus?: JsonNullableVehicleCatalogVerificationStatus
  /** Catalog make-model id this set belongs to (immutable) */
  makeModelId: string
}
export type VehicleEfficiencyModelResetResult = {
  /** Vehicles whose model was reset */
  resetCount?: number
  /** Selected vehicles that could not be reset */
  skippedCount?: number
  /** Ids of the vehicles whose model was reset */
  vehicleIds?: string[]
}
export type VehicleEfficiencyModelBulkResetParams = {
  /** Explicit vehicle ids to reset (1..500); the caller must have access to each */
  vehicleIds?: string[]
  /** Reset every vehicle whose home site is this one (limited to the caller's accessible vehicles) */
  siteId?: string
  /** Reset every vehicle of this organization (the caller needs access to it) */
  organizationId?: string
  /** Samples before this instant are ignored by the predictor from now on; defaults to now. The server rejects a value in the future or more than 3 years back. */
  trainingFrom?: string
  /** Free-text reason recorded on every reset model */
  resetReason?: string
}
export type VehicleEfficiencyBackfillResult = {
  /** COLLECTING rows created by this call */
  created?: number
  /** Active vehicles still without a model row after this call */
  remaining?: number
}
export type VehicleChargeModelResetParams = {
  /** ISO-8601 date-time (UTC) sessions are ignored before; defaults to now. Wins over the trainingFrom query parameter when both are sent. */
  trainingFrom?: string
  /** Free-text reason for the reset, logged with it */
  resetReason?: string
}
export type OrganizationApiKeySummary = {
  /** Row id of the key in fleet-management */
  id?: string
  /** Organization the key authenticates as */
  organizationId?: string
  /** API Gateway key id; null on legacy rows provisioned before the id was recorded */
  awsKeyId?: string
  /** API Gateway usage plan id the key is attached to */
  usagePlanId?: string
  /** Human-readable label */
  label?: string
  /** Audience of the key */
  keyType?: 'EXTERNAL' | 'INTERNAL'
  /** Whether fleet-management resolves the key to its organization */
  active?: boolean
  /** Last four characters of the key value */
  keyLast4?: string
  /** When the row was created */
  created?: string
  /** When the row was last updated */
  updated?: string
  /** When the key was last deactivated; null while it is active */
  deactivatedAt?: string
}
export type ApiKeyMovePlanParams = {
  /** API Gateway usage plan id to move the key to */
  usagePlanId: string
}
export type OrganizationApiKeyRegisterParams = {
  /** API Gateway key id (immutable) */
  awsKeyId: string
  /** API Gateway usage plan id the key is attached to */
  usagePlanId: string
  /** Human-readable label shown in the admin console */
  label?: string
  /** EXTERNAL for a key the organization uses itself, INTERNAL for a Synop or integration key */
  keyType: 'EXTERNAL' | 'INTERNAL'
}
export type OrganizationApiKeyRegisterParamsWrite = {
  /** API Gateway key id (immutable) */
  awsKeyId: string
  /** API Gateway usage plan id the key is attached to */
  usagePlanId: string
  /** The key value as API Gateway returned it on creation; write-only, never returned */
  apiKey: string
  /** Human-readable label shown in the admin console */
  label?: string
  /** EXTERNAL for a key the organization uses itself, INTERNAL for a Synop or integration key */
  keyType: 'EXTERNAL' | 'INTERNAL'
}
export type UsagePlanThrottle = {
  /** Steady-state requests per second */
  rateLimit?: number
  /** Burst capacity in requests */
  burstLimit?: number
}
export type UsagePlanQuota = {
  /** Requests allowed per period */
  limit?: number
  /** DAY, WEEK or MONTH */
  period?: 'DAY' | 'WEEK' | 'MONTH'
  /** Offset into the period at which the quota window starts */
  offset?: number
}
export type UsagePlan = {
  /** API Gateway usage plan id */
  id?: string
  /** Plan name */
  name?: string
  /** Plan description */
  description?: string
  /** Throttle settings */
  throttle?: UsagePlanThrottle
  /** Quota settings */
  quota?: UsagePlanQuota
  /** Number of the organization's recorded keys on this plan */
  keyCount?: number
}
export type JsonNullableUsagePlanThrottle = {
  present?: boolean
  undefined?: boolean
}
export type JsonNullableUsagePlanQuota = {
  present?: boolean
  undefined?: boolean
}
export type UsagePlanUpdateParams = {
  /** Plan name */
  name?: JsonNullableString
  /** Plan description; null clears it */
  description?: JsonNullableString
  /** Throttle settings; null removes throttling from the plan */
  throttle?: JsonNullableUsagePlanThrottle
  /** Quota settings; null removes the quota from the plan */
  quota?: JsonNullableUsagePlanQuota
}
export type JsonNullableOrganizationApiKeyType = {
  present?: boolean
  undefined?: boolean
}
export type OrganizationApiKeyUpdateParams = {
  /** Human-readable label; an explicit null clears it */
  label?: JsonNullableString
  /** false deactivates the key (fleet-management stops resolving it and stamps deactivatedAt); true reactivates it and clears deactivatedAt. An explicit null is rejected. */
  active?: JsonNullableBoolean
  /** Usage plan the key now belongs to, after the caller moved it in API Gateway. An explicit null is rejected. */
  usagePlanId?: JsonNullableString
  /** Audience of the key. An explicit null is rejected. */
  keyType?: JsonNullableOrganizationApiKeyType
  /** API Gateway key id, for a legacy row registered before the id was recorded. Accepted only while the row has no awsKeyId; a different value on a row that has one is rejected with a 409. An explicit null is rejected. */
  awsKeyId?: JsonNullableString
}
export type VehicleCatalogResolution = {
  /** Vehicle id */
  vehicleId?: string
  manufacturer?: VehicleCatalogManufacturer
  makeModel?: VehicleCatalogMakeModel
  capabilitySet?: VehicleCatalogCapabilitySet
  /** Whether the capability set was pinned explicitly on the vehicle rather than resolved from the make-model */
  capabilitySetPinned?: boolean
  /** How the vehicle was linked to its make-model */
  catalogLinkSource?: 'USER' | 'PROVIDER' | 'VIN_DECODE' | 'BACKFILL' | 'ADMIN' | 'DEFAULT'
  /** Active curves of the capability set; curves belong to the set, never to a vehicle */
  powerCurves?: VehicleCatalogPowerCurve[]
  /** The charge curve the resolver picks for planning: the active LEARNED curve with confidence >= 0.5 of the highest charger class, else the active AUTHORED curve, else the active OEM_SPEC curve; null when the set has none */
  effectiveChargeCurve?: VehicleCatalogPowerCurve
  /** The capability set's charge model state; null when the set has never been fitted */
  chargeModel?: VehicleChargeModel
}
export type VehicleEfficiencySample = {
  /** Trip id */
  tripId?: string
  /** Vehicle id */
  vehicleId?: string
  /** Trip start (UTC) */
  startedAt?: string
  /** Trip end (UTC) */
  endedAt?: string
  /** Trip duration in minutes */
  duration?: number
  /** Distance driven in km, converted from the trip's stored unit (km, m = metres, or mi); null when the unit is missing or unrecognised */
  distance?: number
  /** Energy consumed in kWh: the trip's positive energy-used reading, else battery capacity x SOC delta when the delta is at least 5 percent; see energySource */
  energy?: number
  /** Where the energy figure came from */
  energySource?: 'PROVIDER' | 'SOC' | 'NONE'
  /** Efficiency in kWh/km, always derived as energy / distance; the trip's stored efficiency column is never used */
  efficiency?: number
  /** Mean ambient temperature over the trip window in degrees C (forecast rows within an hour of the trip, else telemetry) */
  ambientTemperature?: number
  /** Where the ambient temperature came from */
  temperatureSource?: 'WEATHER_FORECAST' | 'TELEMETRY' | 'NONE'
  /** How many hourly temperature readings the mean is over; 0 when temperatureSource is NONE */
  temperatureSampleCount?: number
  /** Payload weight in kg: the scheduled route overlapping the trip, else that route's own weight, else the mean gross combination weight telemetry over the trip window, else null; see payloadSource */
  payloadWeight?: number
  /** Where the payload weight came from */
  payloadSource?: 'SCHEDULED_ROUTE' | 'ROUTE' | 'NONE' | 'TELEMETRY'
  /** Route id of the scheduled route overlapping the trip, when there is one */
  routeId?: string
  /** Source of the underlying trip record; simulator and geofence-generated trips are never returned */
  source?: string
  /** Informational quality flags; the predictor decides which to drop */
  quality?: (
    | 'SHORT_TRIP'
    | 'IMPLAUSIBLE_EFFICIENCY'
    | 'NO_TEMPERATURE'
    | 'NO_ENERGY'
    | 'NEGATIVE_ENERGY'
    | 'UNKNOWN_DISTANCE_UNIT'
  )[]
}
export type VehicleVinDecode = {
  /** VIN, upper-case */
  vin?: string
  /** World Manufacturer Identifier: the first three VIN characters */
  wmi?: string
  /** vPIC Make */
  vpicMake?: string
  /** vPIC Manufacturer, the legal manufacturer name */
  manufacturerName?: string
  /** vPIC Model */
  model?: string
  /** vPIC Series */
  series?: string
  /** vPIC Trim */
  trim?: string
  /** vPIC ModelYear */
  modelYear?: number
  /** vPIC BodyClass */
  bodyClass?: string
  /** vPIC GVWR, the gross vehicle weight rating class as vPIC words it */
  gvwrClass?: string
  /** vPIC ElectrificationLevel */
  electrificationLevel?: string
  /** vPIC BatteryKWh: nameplate battery size (kWh) */
  batterySize?: number
  /** Outcome of the decode */
  status?: 'DECODED' | 'PARTIAL' | 'FAILED'
  /** vPIC ErrorText, or why the lookup failed */
  errorText?: string
  /** When vPIC was last asked about this VIN */
  decodedAt?: string
}
export type PaginationMetadata = {
  first: boolean
  last: boolean
  pageSize: number
  page: number
  totalPages: number
  totalItems: number
}
export type Meta = {
  pagination: PaginationMetadata
}
export type SourceAttributeValueBigDecimal = {
  units?: string
  lastUpdated?: number
  source?: string
  value?: number
}
export type LocationOfInterestModel = {
  id?: string
  type?: string
}
export type SourceAttributeValueString = {
  units?: string
  lastUpdated?: number
  source?: string
  value?: string
}
export type CurrentLocation = {
  locationOfInterestModels?: LocationOfInterestModel[]
  bearing?: SourceAttributeValueBigDecimal
  cardinalDirection?: SourceAttributeValueString
  street?: SourceAttributeValueString
}
export type Subscription = {
  isSubscriptionActive?: boolean
  subscriptionType?: string
  subscriptionTerm?: string
  startDate?: string
  endDate?: string
  autoRenewal?: boolean
}
export type Fault = {
  code?: string
  name?: string
  description?: string
  latitude?: number
  longitude?: number
  sourceAddress?: string
  parameterIdentifier?: string
  failureModeIndicator?: string
  occurrenceCount?: number
  lastUpdated?: number
  provider?: string
  faultType?: number
  mil?: string[]
}
export type ChargePortModel = {
  /** Human-readable name for the charge port (e.g. "Front port", "Left inlet"). Used to disambiguate ports on multi-port vehicles. */
  name?: string
  /** Charge port / connector type; used for reporting and display. Optional -- omit it if the connector standard is unknown. Values are case- and space-sensitive and must be one of the listed options. */
  type?: 'J1772' | 'Type 2' | 'CHAdeMO' | 'CCS1' | 'CCS2' | 'NACS' | 'MCS' | 'Other'
  /** OCPP auth tag (idTag) to associate with this charge port. Optional. When provided, the value is normalized before storage and must be unique across your organization's active auth tags; a duplicate returns 409 Conflict. Registering an auth tag also registers the corresponding OCPP id-tag variants so chargers will accept it on transaction start. */
  authTag?: string
  /** The id for a charge port */
  id: string
  /** The vehicle id that this charge port is mapped to */
  vehicleId: string
}
export type VehicleAuthTagModel = {
  /** The id for a charge port */
  chargePortId: string
  /** The id for a vehicle the charge port is mapped to */
  vehicleId: string
  /** The datetime that the auth tag is valid from */
  validFrom: string
  /** The datetime that the auth tag is valid to */
  validTo?: string
  /** The status of the auth tag mapped to this port */
  status: 'ACTIVE' | 'DEACTIVATED'
  /** The name for a charge port */
  name?: string
  /** The type for a charge port */
  type?: string
  /** The auth tag mapped to the charge port */
  authTag: string
  /** The normalized version of the auth tag that is mapped to the charge port */
  normalizedAuthTag: string
}
export type VehicleModel = {
  /** The vin for a vehicle */
  vin: string
  /** The name for a vehicle */
  vehicleNm: string
  /** The display name for a vehicle */
  vehicleDisplayNm?: string
  /** The organizationId for a vehicle */
  organizationId: string
  /** The make for a vehicle */
  make: string
  /** The model for a vehicle */
  model: string
  /** The model year for a vehicle */
  modelYear: number
  /** Unique identifier for the site where the vehicle is based */
  homeSiteId?: string
  /** The battery size for a vehicle in kWh */
  batterySize: number
  /** The efficiency for a vehicle, unit is set by efficiencyUnit */
  efficiency?: number
  /** The efficiency unit for a vehicle, defaults to kWh/mi */
  efficiencyUnit?: 'km/kwh' | 'kwh/km' | 'mi/kwh' | 'kwh/mi'
  /** The estimated range for a vehicle, unit is set by estimatedRangeUnit */
  estimatedRange: number
  /** The estimated range unit for a vehicle, defaults to mi */
  estimatedRangeUnit?: 'mi' | 'km'
  /** The weight for a vehicle */
  weight: SourceAttributeValueBigDecimal
  /** The external id for a vehicle */
  externalId?: string
  /** The commissioning status for a vehicle */
  vehicleCommissionStatus?: 'PRE_COMMISSIONED' | 'COMMISSIONED' | 'MAINTENANCE' | 'OUT_OF_SERVICE' | 'DECOMMISSIONED'
  /** Minimum state of charge threshold for the vehicle (0-100) */
  minSoc?: number
  /** Maximum state of charge threshold for the vehicle (0-100). When null, the vehicle inherits the site-level default. */
  maxSoc?: number
  /** Whether the vehicle has an associated simulator */
  hasSimulator?: boolean
  /** Default loading time in minutes before a trip, during which the vehicle cannot charge. A scheduled trip may override it. */
  defaultLoadingMinutes?: number
  /** Maximum charge rate for the vehicle in kW. When null, no vehicle-level cap applies. */
  maxChargeRateKw?: number
  /** Whether the vehicle is autonomous. Defaults to false. */
  isAutonomous?: boolean
  /** Catalog make-model to link the vehicle to. When omitted, make/model are matched against the catalog by name and fall back to the Uncatalogued entry. When present, make/model are set from the catalog. */
  makeModelId?: string
  /** Pin the vehicle to a specific capability-set version of its make-model. When omitted, the set is resolved from the make-model and model year. Sending back the currently resolved, unpinned set does not pin it. */
  capabilitySetId?: string
  /** Trim / configuration label, e.g. battery variant */
  variantName?: string
  /** Unique identifier for a vehicle in the Synop system */
  id: string
  /** Type of vehicle */
  vehicleType?: string
  /** Whether capabilitySetId was pinned explicitly rather than resolved from the make-model */
  capabilitySetPinned?: boolean
  /** How the vehicle was linked to its catalog make-model */
  catalogLinkSource?: 'USER' | 'PROVIDER' | 'VIN_DECODE' | 'BACKFILL' | 'ADMIN' | 'DEFAULT'
  /** The macAddress for a vehicle. This field is deprecated and will be removed on June 25, 2025. Please use the chargePorts field instead. */
  macAddress?: string
  /** Class of vehicle */
  vehicleClass?: number
  /** Whether the vehicle is active in the system or not. Inactive vehicles may not collect new telemetry */
  active?: boolean
  /** Whether the vehicle has been logically deleted from the system */
  logicalDeleteIn?: boolean
  /** Provider ID of the vehicle. This usually is defined by the upstream telematics source */
  providerId?: string
  /** Whether the vehicle is capable of vehicle-to-grid operations */
  vehicleToGridCapable?: boolean
  /** Lifetime efficiency of the vehicle */
  lifetimeEfficiency?: number
  /** Unique identifier for the fleet to which the vehicle belongs */
  fleetId?: string
  /** Name of the fleet to which the vehicle belongs */
  fleetNm?: string
  /** The name of the organization to which the vehicle belongs */
  organizationNm?: string
  /** Unique identifier for the organization that is billed for this vehicle. Check the billing module for more information */
  billingOrganizationId?: string
  /** Current location of interest the vehicle is in */
  currentLocation?: CurrentLocation
  /** Status of the vehicle as of the telematics timestamp */
  vehicleStatus?: SourceAttributeValueString
  /** Latitude of the vehicle as of the telematics timestamp */
  latitude?: SourceAttributeValueBigDecimal
  /** Longitude of the vehicle as of the telematics timestamp */
  longitude?: SourceAttributeValueBigDecimal
  /** Remaining charge time of the vehicle caculated as of the telematics timestamp */
  remainingChargeTime?: SourceAttributeValueBigDecimal
  /** Remaining range of the vehicle calculated as of the telematics timestamp */
  remainingRange?: SourceAttributeValueBigDecimal
  /** State of charge of the vehicle as of the telematics timestamp */
  stateOfCharge?: SourceAttributeValueBigDecimal
  /** Odometer reading of the vehicle as of the telematics timestamp */
  odometer?: SourceAttributeValueBigDecimal
  /** Speed of the vehicle as of the telematics timestamp */
  speed?: SourceAttributeValueBigDecimal
  /** State of the 12V system */
  batteryPotential?: SourceAttributeValueBigDecimal
  /** Distance from current location to the home site */
  distanceUntilHome?: SourceAttributeValueBigDecimal
  /** Time it would take to go from current location to the home site */
  timeUntilHome?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime engine on time */
  engineOnLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime driving time */
  drivingTimeLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime EPTO use time */
  eptoUseLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime battery discharge energy */
  batteryDischargeLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime battery regen energy */
  batteryRegenLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime energy used by the HVAC system */
  tracInverterMotorLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime energy used by the HVAC system */
  tracInverterRegenLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime energy used by the HVAC system */
  batteryManagementLifetime?: SourceAttributeValueBigDecimal
  dcdcLifetime?: SourceAttributeValueBigDecimal
  /** Aggregate lifetime energy used by the HVAC system */
  hvacLifetime?: SourceAttributeValueBigDecimal
  /** Average charger power supplied to the vehicle */
  chargerPowerSupplied?: SourceAttributeValueBigDecimal
  /** Subscriptions attached to this vehicle. Check the billing module for more information */
  subscriptions?: Subscription[]
  /** Active faults attached to this vehicle */
  faults?: Fault[]
  /** Telematics timestamp of the latest data received for the vehicle */
  telematicsTimestamp?: string
  /** Telematics timestamp of the latest data received for the vehicle in epoch milliseconds */
  telematicsTimestampEpochMillisecond?: number
  /** Ambient air temperature captured as of the vehicle as of the telematics timestamp */
  ambientAirTemperature?: SourceAttributeValueBigDecimal
  /** Whether the vehicle is in the home site or not */
  inDepot?: boolean
  /** Charge Ports mapped to this vehicle */
  chargePorts?: ChargePortModel[]
  /** A list of all auth tags associated with this vehicle (historical & current) */
  vehicleAuthTags?: VehicleAuthTagModel[]
}
export type PagedResponseV2VehicleModel = {
  meta: Meta
  data: VehicleModel[]
}
export type VehicleEfficiencyModelListItem = {
  /** The vehicle's efficiency model state */
  model?: VehicleEfficiencyModel
  /** Organization the vehicle belongs to */
  organizationId?: string
  /** Home site of the vehicle */
  homeSiteId?: string
  /** Catalog make-model the vehicle is linked to */
  makeModelId?: string
  /** Catalog capability set the vehicle is linked to */
  capabilitySetId?: string
  /** The vehicle's configured efficiency in kWh/km */
  vehicleEfficiency?: number
  /** The vehicle's battery capacity in kWh */
  batteryCapacity?: number
  /** Whether the vehicle is active */
  vehicleActive?: boolean
}
export type PagedResponseV2VehicleEfficiencyModelListItem = {
  meta: Meta
  data: VehicleEfficiencyModelListItem[]
}
export type VehicleChargeModelListItem = {
  /** Capability set the model belongs to; the keyset cursor of the listing */
  capabilitySetId?: string
  /** COLLECTING, TRAINED or STALE */
  status?: 'COLLECTING' | 'TRAINED' | 'STALE'
  /** When the set's curves were last fit; null until they have been */
  lastFittedAt?: string
  /** Fitter model version of the last fit */
  modelVersion?: string
  /** Charging sessions the last fit pooled */
  sessionCount?: number
}
export type PagedResponseV2VehicleChargeModelListItem = {
  meta: Meta
  data: VehicleChargeModelListItem[]
}
export type ApiKeyUsageItem = {
  /** Day (UTC) */
  date?: string
  /** Requests used that day */
  used?: number
  /** Requests remaining in the quota period */
  remaining?: number
}
export type ApiKeyUsage = {
  /** Row id of the key */
  keyId?: string
  /** API Gateway key id */
  awsKeyId?: string
  /** Usage plan id the usage was read from */
  usagePlanId?: string
  /** First day of the window (inclusive) */
  startDate?: string
  /** Last day of the window (inclusive) */
  endDate?: string
  /** One entry per reported day */
  items?: ApiKeyUsageItem[]
}
export type ChargerClass = 'UNKNOWN' | 'AC_7' | 'AC_22' | 'AC_HIGH' | 'DC_50' | 'DC_150' | 'DC_HIGH'
export type CohortType = 'MAKE_MODEL' | 'GLOBAL'
export type ChargeCohortOut = {
  id: string
  type: CohortType
}
export type SocRangeOut = {
  from: number
  to: number
}
export type PowerCurveDirection = 'CHARGE' | 'DISCHARGE'
export type ChargeFallbackLevel = 'CAPABILITY_SET' | 'MAKE_MODEL' | 'GLOBAL' | 'PRIOR'
export type PowerCurveInterpolation = 'LINEAR' | 'STEP'
export type ChargeModelStatus = 'COLLECTING' | 'TRAINED' | 'STALE'
export type ChargeModelSummaryOut = {
  coverageBasis?: string | null
  holdoutBasis?: string | null
  holdoutBiasMinutes?: number | null
  holdoutBiasShare?: number | null
  holdoutRunCount?: number | null
  holdoutThrottledRunCount?: number | null
  holdoutVehicleLimitedShare?: number | null
  lastFittedAt?: string | null
  modelVersion?: string | null
  status?: ChargeModelStatus | null
}
export type ChargePointOut = {
  power: number
  soc: number
}
export type PowerCurveRegionSource = 'MEASURED' | 'COHORT' | 'LOWER_BOUND'
export type RegionOut = {
  from: number
  source: PowerCurveRegionSource
  to: number
}
export type EffectiveCurveSource = 'LEARNED' | 'AUTHORED' | 'OEM_SPEC' | 'COHORT' | 'PRIOR'
export type ChargeCurveOut = {
  capabilitySetId: string
  censoredShare?: number | null
  chargerClass?: ChargerClass | null
  cohort?: ChargeCohortOut | null
  confidence?: number | null
  coverage?: SocRangeOut | null
  direction: PowerCurveDirection
  fallbackLevel: ChargeFallbackLevel
  interpolation: PowerCurveInterpolation
  model: ChargeModelSummaryOut
  points: ChargePointOut[]
  regions?: RegionOut[]
  source: EffectiveCurveSource
  vehicleId?: string | null
}
export type ErrorBody = {
  code: string
  message: string
  param?: string | null
  type: 'invalid_request_error' | 'not_found' | 'upstream_error' | 'authentication_error' | 'api_error'
}
export type ErrorResponse = {
  error: ErrorBody
}
export type ValidationError = {
  ctx?: object
  input?: unknown
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type ChargerClassParam = 'AC_7' | 'AC_22' | 'AC_HIGH' | 'DC_50' | 'DC_150' | 'DC_HIGH'
export type Direction = 'charge' | 'discharge'
export type ChargeRefitCurveOut = {
  chargerClass: ChargerClass
  confidence: number
  coverage?: SocRangeOut | null
  gate?: string | null
  points?: ChargePointOut[] | null
  written: boolean
}
export type ChargeModelOut = {
  capabilitySetId: string
  censoredShare?: number | null
  chargingEfficiency?: number | null
  confidence?: number | null
  coverageBasis?: string | null
  fallbackLevel: ChargeFallbackLevel
  holdoutBasis?: string | null
  holdoutBiasMinutes?: number | null
  holdoutBiasShare?: number | null
  holdoutMedianApe?: number | null
  holdoutP90Ape?: number | null
  holdoutRunCount?: number | null
  holdoutThrottledRunCount?: number | null
  holdoutVehicleLimitedShare?: number | null
  kneeSoc?: number | null
  lastFittedAt?: string | null
  lastSessionAt?: string | null
  modelVersion: string
  sessionCount: number
  socCoverageFrom?: number | null
  socCoverageTo?: number | null
  status: ChargeModelStatus
  trainingFrom?: string | null
  vehicleCount: number
}
export type ChargeRefitOut = {
  capabilitySetId: string
  curves: ChargeRefitCurveOut[]
  dryRun: boolean
  model: ChargeModelOut
}
export type CohortType2 = 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL'
export type CohortOut = {
  id: string
  label?: string | null
  type: CohortType2
}
export type QuantilesOut = {
  p10: number
  p50: number
  p90: number
}
export type PayloadFactorOut = {
  confidence?: number | null
  mass?: number | null
  multiplier: number
}
export type WeatherFactorOut = {
  multiplier: number
  temperature?: number | null
}
export type FactorsOut = {
  payload?: PayloadFactorOut | null
  residualAdjustment: number
  weather: WeatherFactorOut
}
export type FallbackLevel = 'VEHICLE' | 'CAPABILITY_SET' | 'MAKE_MODEL' | 'ORGANIZATION' | 'SITE' | 'GLOBAL' | 'PRIOR'
export type ModelOut = {
  name: string
  version: string
}
export type ResidualBacktestOut = {
  coverage?: number | null
  wape?: number | null
}
export type ResidualLevel = 'VEHICLE' | 'COHORT'
export type ResidualStatus = 'SERVED' | 'NOT_SERVED' | 'BASELINE_CHANGED' | 'STALE' | 'DISABLED'
export type ResidualModelOut = {
  backtest?: ResidualBacktestOut | null
  issuedAt?: string | null
  level?: ResidualLevel | null
  name?: string
  status: ResidualStatus
  version?: string | null
}
export type EfficiencyModelStatus = 'COLLECTING' | 'TRAINED' | 'STALE'
export type TemperatureSource = 'SITE' | 'HOME_SITE' | 'NONE'
export type EnergyEstimateOut = {
  baseline: number
  cohort?: CohortOut | null
  confidence: number
  departureAt: string
  distance: number
  efficiency: number
  energy: number
  energyQuantiles?: QuantilesOut | null
  explanation: string[]
  factors: FactorsOut
  fallbackLevel: FallbackLevel
  model: ModelOut
  residualModel?: ResidualModelOut | null
  siteId?: string | null
  status: EfficiencyModelStatus
  temperatureSource: TemperatureSource
  vehicleId: string
}
export type EnergyEstimateIn = {
  departureAt: string
  distance: number
  payload?: number | null
  siteId?: string | null
  vehicleId: string
}
export type RefitErrorOut = {
  code: string
  message: string
  type: 'invalid_request_error' | 'not_found' | 'upstream_error' | 'authentication_error' | 'api_error'
}
export type RefitOutcome = 'fitted' | 'unknown' | 'failed' | 'held' | 'not_servable'
export type ChargeRefitItemOut = {
  capabilitySetId: string
  curves?: ChargeRefitCurveOut[]
  error?: RefitErrorOut | null
  model?: ChargeModelOut | null
  outcome: RefitOutcome
}
export type ChargeRefitBulkOut = {
  dryRun: boolean
  failed: number
  fitted: number
  requested: number
  results: ChargeRefitItemOut[]
  unknown: number
}
export type ChargeCurveFitIn = {
  capabilitySetIds?: string[] | null
  dryRun?: boolean
}
export type BaselineSource = 'VEHICLE' | 'CAPABILITY_SET' | 'COHORT' | 'OWN_MEDIAN' | 'COHORT_MEDIAN'
export type FitHealthOut = {
  binsPopulated?: number | null
  blocks365?: number | null
  blocksLast30d?: number | null
  heldReason?: string | null
  lastBlockEndAt?: string | null
  notServableReason?: string | null
  readThroughAt?: string | null
  state: string
  temperatureSpanC?: number | null
  untouchedSince?: string | null
}
export type SampleKind = 'BLOCK' | 'TRIP' | 'UNKNOWN'
export type ModelInfoOut = {
  issuedAt?: string | null
  name: string
  sampleKind?: SampleKind
  version: string
}
export type PayloadModelOut = {
  sampleCount?: number | null
  slope: number
  typicalPayload?: number | null
}
export type CurvePointOut = {
  multiplier: number
  temperature: number
}
export type EfficiencyModelOut = {
  baselineEfficiency?: number | null
  baselineSource?: BaselineSource | null
  cohort?: CohortOut | null
  confidence?: number | null
  fallbackLevel: FallbackLevel
  fitHealth?: FitHealthOut | null
  lastFittedAt?: string | null
  maxTemperature?: number | null
  minTemperature?: number | null
  model: ModelInfoOut
  payload?: PayloadModelOut | null
  resetAt?: string | null
  resetCount?: number
  residualAdjustment: number
  residualModel?: ResidualModelOut | null
  sampleCount: number
  /** What the model row's samples are: the kind sampleCount counts. The row's own provenance, read off its modelVersion (a block suffix is BLOCK, any other version TRIP); when the version says nothing (a legacy 1.0.0 or empty version) the fitter's EFFICIENCY_SAMPLE_SOURCE in this environment (BLOCKS is BLOCK, FM_TRIPS is TRIP). UNKNOWN is never emitted here. Equals model.sampleKind except where that is UNKNOWN. */
  sampleKind: SampleKind
  status: EfficiencyModelStatus
  trainingFrom?: string | null
  vehicleId: string
  weatherCurve?: CurvePointOut[]
}
export type EfficiencyRefitItemOut = {
  error?: RefitErrorOut | null
  model?: EfficiencyModelOut | null
  outcome: RefitOutcome
  reason?: string | null
  vehicleId: string
}
export type EfficiencyRefitOut = {
  dryRun: boolean
  failed: number
  fitted: number
  held?: number
  notServable?: number
  requested: number
  results: EfficiencyRefitItemOut[]
  unknown: number
}
export type EfficiencyFitIn = {
  asOf?: string | null
  dryRun?: boolean
  vehicleIds?: string[] | null
}
export type RunBlocksOut = {
  budgetSeconds: number
  dbSeconds: {
    [key: string]: number
  }
  statements: number
  stops: string[]
  vehicles: {
    [key: string]: number
  }
  waves: number
}
export type RunFitOut = {
  held: {
    [key: string]: number
  }
  indexAgeHours?: number | null
  outcomes: {
    [key: string]: number
  }
}
export type FitRunsLatestOut = {
  blocks?: RunBlocksOut | null
  cohorts?: {
    [key: string]: number
  }
  fit?: RunFitOut | null
  night: string | null
}
export type HealthResponse = {
  service: string
  status: string
  version: string
}
export type CenterOut = {
  lat: number
  lon: number
}
export type DepotStatsOut = {
  chargeShare?: number | null
  nights?: number | null
  vehicles?: number | null
}
export type PlaceVersionOut = {
  geometryBasis: string
  version: string
  versionHash?: string | null
}
export type PlaceOut = {
  areaM2?: number | null
  center?: CenterOut | null
  depot?: DepotStatsOut | null
  geometryBasis: string
  isHome?: boolean | null
  kind: string
  placeId: string
  private?: boolean
  radiusM?: number | null
  siteId?: string | null
  supersedesPlaceId?: string | null
  tz?: string | null
  version: string
  versions?: PlaceVersionOut[] | null
}
export type PlaceListOut = {
  data: PlaceOut[]
  hasMore: boolean
  nextCursor?: string | null
  object?: 'list'
}
export type PlaceRefOut = {
  geometryBasis: string
  id: string
  kind: string
  siteId?: string | null
  version: string
}
export type VisitOut = {
  confidence: number
  coverageClass: string
  dwellSeconds?: number | null
  enterAt: string
  enterGapSeconds?: number | null
  enterQuality: string
  homeMatch: string
  insideFixCount: number
  leaveAt?: string | null
  leaveGapSeconds?: number | null
  leaveQuality?: string | null
  mergedCount: number
  open: boolean
  place: PlaceRefOut
  provider?: string | null
  schemaVersion: number
  sourceStage: string
  updatedAt: string
  vehicleId: string
  visitId: string
}
export type FreshnessOut = {
  incrementalThrough?: string | null
  nightlyThrough?: string | null
}
export type VisitListOut = {
  data: VisitOut[]
  freshness?: FreshnessOut | null
  hasMore: boolean
  nextCursor?: string | null
  object?: 'list'
}
export type PlanEvaluationSummaryOut = {
  date: string
  failed: string[]
  generatedAt: string | null
  notEvaluable: string[]
  options: number | null
  passed: boolean
  plans: number | null
  stubs: string[]
}
export type PlanEvaluationListOut = {
  evaluations: PlanEvaluationSummaryOut[]
  from: string
  to: string
}
export type GateResultOut = {
  detail: string
  gate: string
  status: string
  stub: boolean
  threshold: unknown
  value: unknown
}
export type PlanEvaluationOut = {
  date: string
  failed: string[]
  feedFreshness: {
    [key: string]: {
      [key: string]: unknown
    }[]
  }
  gates: GateResultOut[]
  generatedAt: string | null
  modelHealthRows: number | null
  notEvaluable: string[]
  options: number | null
  passed: boolean
  plans: number | null
  stubs: string[]
}
export type HeartbeatLeaseOut = {
  expiresAt: string | null
  held: boolean
}
export type LastEvaluationOut = {
  date: string
  failed: string[]
  generatedAt: string | null
  notEvaluable: string[]
  passed: boolean
  stubs: string[]
}
export type PlansEnvironmentHealthOut = {
  generatedAt: string
  heartbeatLease: HeartbeatLeaseOut | null
  lastEvaluation: LastEvaluationOut | null
  optimizerWiring: 'none'
  paused: boolean | null
}
export type BaselineOut = {
  co2: number
  cost: number
  label: string | null
  onTimeProbability: number
  peakKw: number
  planId: string | null
}
export type OptionAbsoluteOut = {
  co2: number
  cost: number
  onTimeProbability: number
  peakKw: number
}
export type AffectedRefOut = {
  effect: string
  id: string
  type: string
}
export type OptionDeltasOut = {
  co2: number
  cost: number
  onTimeRisk: number
  peakKw: number
}
export type AnchorTargetOut = {
  id: string | null
  type: string
}
export type AnchorOut = {
  end: number
  resolved: boolean
  start: number
  target: AnchorTargetOut
  unresolvedReason?: string | null
}
export type SentenceOut = {
  anchors: AnchorOut[]
  text: string
}
export type ExplanationSubjectOut = {
  id: string
  type: string
}
export type ExplanationOut = {
  createdAt: string
  explanationId: string
  generator: string
  planId: string
  sentences: SentenceOut[]
  subject: ExplanationSubjectOut
}
export type InfeasibleReasonOut = {
  anchors: AnchorOut[]
  text: string
}
export type StateReasonOut = {
  category: string
  text: string
}
export type OptionSubjectOut = {
  id: string
  routeId: string | null
  type: 'route' | 'vehicle' | 'site'
  vehicleId: string | null
}
export type OptionOut = {
  absolute: OptionAbsoluteOut
  affected: string[]
  affectedRefs: AffectedRefOut[]
  createdAt: string
  delivery: string
  deltas: OptionDeltasOut
  explanation?: ExplanationOut | null
  gate: string
  infeasibleReason?: InfeasibleReasonOut | null
  inputsHash: string
  onTimeProbability: number
  onTimeProbabilityStdErr: number
  onTimeRiskUnit: string
  optionId: string
  params: {
    [key: string]: unknown
  }
  pareto: boolean
  planId: string
  planLabel: string
  rank: number | null
  relaxedConstraint:
    | 'departure_time'
    | 'charger_assignment'
    | 'target_soc'
    | 'priority'
    | 'carbon_weight'
    | 'dock_vs_yard'
  relaxedConstraintLabel: string
  state: string
  stateReason?: StateReasonOut | null
  subject: OptionSubjectOut
  title: string
  updatedAt: string
}
export type ObjectiveOut = {
  carbonCost: number
  carbonKg: number
  carbonPrice: number | null
  currency: string
  degradation: number
  demandCharge: number
  energyCost: number
  onTimePenalty: number
  overridePenalty: number
  smoothing: number
  total: number
}
export type ComparedPlanOut = {
  label: string
  macro: {
    [key: string]: unknown
  } | null
  objective: ObjectiveOut
  planId: string
}
export type PlanCompareOut = {
  baseline: BaselineOut
  options: OptionOut[]
  plans: ComparedPlanOut[]
}
export type PlanAuthorOut = {
  id: string
  onBehalfOf?: string | null
  type: 'system' | 'user' | 'assistant'
}
export type BindingConstraintOut = {
  affectedVehicleIds: string[]
  constraintId: string
  from: string
  label: string
  scope: {
    [key: string]: unknown
  }
  shadowPrice: number | null
  to: string
  type: string
  unit: string | null
}
export type ChecksOut = {
  checker: string
  maxViolationKw: number
  maxViolationKwh: number
  violations: number
}
export type ExcludedVehicleOut = {
  reason: string
  vehicleId: string
}
export type FeedOut = {
  basis?: string | null
  eventIds?: string[] | null
  issuedAt: string
  name: string
  provider: string | null
  staleVehicles?: number | null
  vehicles?: number | null
}
export type HorizonOut = {
  from: string
  nSlots: number
  to: string
}
export type InputsOut = {
  declaredDemand?: ('lake' | 'absent') | null
  flags: string[]
  lakeMarkers: {
    [key: string]: unknown
  }
  siteLimit?: ('bounded' | 'unbounded' | 'mixed') | null
  snapshotKey: string | null
  stepCount?: number | null
  stepMinutes?: number | null
  timeGrid?: ('persisted' | 'derived-uniform') | null
}
export type ModelVersionOut = {
  capability: string
  model: string
  owner: string
  status?: string | null
  version?: string | null
}
export type OptionSetOut = {
  optionIds: string[]
  subject: ExplanationSubjectOut
  truncated: boolean
}
export type OptionsBudgetOut = {
  limitS: number
  truncated: boolean
  usedS: number
}
export type PinOut = {
  chargerId: string | null
  connectorId: number | string | null
  expiresAt: string | null
  overrideId: string
  state: string
  vehicleId: string | null
}
export type SolverOut = {
  binding: string
  durationS: number
  gap: number
  method: string
  nCons: number
  nVars: number
  pass: string
  solver: string
  status: string
  version: string | null
}
export type ForecastRefOut = {
  pk: string
  sk: string
}
export type TriggerDetailOut = {
  forecast: ForecastRefOut | null
  overrideId: string | null
  previewId: string | null
  routeIds: string[]
}
export type VerdictBindingOut = {
  constraintId: string
  from: string
  to: string
  type: string
}
export type ReadyAtOut = {
  p10: string | null
  p50: string | null
  p90: string | null
}
export type VerdictOut = {
  bindingConstraint: VerdictBindingOut | null
  computedAt: string
  declaredDeparture: string
  onTimeProbability: number
  optionSetId: string | null
  planId: string
  planLabel: string
  proposedVehicleId: string | null
  readyAt: ReadyAtOut
  reason: SentenceOut
  routeId: string
  slackMin: number | null
  stale: boolean
  vehicleId: string | null
  verdict: 'feasible' | 'watch' | 'infeasible' | 'needsVehicle'
}
export type WeightsOut = {
  carbonKgPerDay: number | null
  carbonMode: string
  carbonWeightPerKg: number
  currency: string
  priceWeight: number
  source: string
}
export type PlanVersionOut = {
  author: PlanAuthorOut
  bindingConstraints: BindingConstraintOut[]
  carbonBasis?: string | null
  carbonShadowPrice: number | null
  checks: ChecksOut
  excludedVehicles: ExcludedVehicleOut[]
  feeds: FeedOut[]
  forecastsKey: string
  horizon: HorizonOut
  inputs: InputsOut
  inputsHash: string
  intentText?: string | null
  issuedAt: string
  kind: 'HEARTBEAT' | 'EVENT' | 'DAY_AHEAD' | 'PREVIEW'
  label: string
  macro: {
    [key: string]: unknown
  } | null
  mode: 'REPLAY' | 'LIVE'
  modelVersions: ModelVersionOut[]
  nextSolveAt: string
  objective: ObjectiveOut
  optimizerInput: {
    [key: string]: unknown
  }
  optimizerInputEligible: boolean
  optionSets: OptionSetOut[]
  optionsBudget?: OptionsBudgetOut | null
  orgId: string | null
  overrideStates?: {
    [key: string]: unknown
  } | null
  overrides: string[]
  parentPlanId: string | null
  pins: PinOut[]
  planId: string
  previewId: string | null
  region: string
  retentionUntil?: string | null
  schemaVersion: 1
  siteId: string
  solvedAt: string
  solver: SolverOut
  trigger: string
  triggerDetail: TriggerDetailOut
  validFrom: string
  validUntil: string
  verdicts: VerdictOut[]
  weights: WeightsOut
}
export type FeedFreshnessOut = {
  ageS: number | null
  eventId?: string | null
  issuedAt: string | null
  name: string
  provider: string | null
  sla: number | string | null
  state: 'fresh' | 'stale'
  vehiclesUsingLastKnown?: number | null
}
export type QualityGatesOut = {
  date: string
  failed: string[]
  notEvaluable: string[]
  passed: boolean
  stubs: string[]
}
export type LastHeartbeatOut = {
  planId: string
  writtenAt: string | null
}
export type CurrentPlanHealthOut = {
  ageS: number | null
  asOf: string
  flags: string[]
  kind: 'HEARTBEAT' | 'EVENT' | 'DAY_AHEAD' | 'PREVIEW'
  label: string
  mode: 'REPLAY' | 'LIVE'
  nextSolveAt: string | null
  overdueS: number | null
  planId: string
  solverStatus: string
  violations: number
  writtenAt: string | null
}
export type PlansSiteHealthOut = {
  excludedVehicles: ExcludedVehicleOut[]
  feeds: FeedFreshnessOut[]
  gates: QualityGatesOut | null
  generatedAt: string
  lastHeartbeat: LastHeartbeatOut | null
  optimizerWiring: 'none'
  plan: CurrentPlanHealthOut | null
  siteId: string
  staleFeeds: number
  state: 'ok' | 'stale' | 'failing' | 'never_planned'
}
export type ModelCoverageOut = {
  band: string
  nominal: number
  observed: number
}
export type ModelDriftOut = {
  biasFrom: number | null
  biasTo: number | null
  coverageDrop: number | null
  note: string
  overDays: number
  state: 'ok' | 'alarm'
}
export type ModelHealthRowOut = {
  accuracy: number | null
  bias: number | null
  capability: 'departure_time' | 'energy_need' | 'arrival_soc' | 'charge_power' | 'vehicle_state'
  capabilitySetId: string
  computedAt: string
  coverage: ModelCoverageOut | null
  drift: ModelDriftOut | null
  mad: number | null
  model: string
  n: number
  provider: string
  rollbackExecutable: boolean
  rollbackTarget: string | null
  siteId: string
  status: 'ok' | 'unavailable'
  unit: string
  version: string | null
  windowDays: number
}
export type ModelHealthOut = {
  feeds: FeedFreshnessOut[]
  models: ModelHealthRowOut[]
}
export type ShadowComparisonOut = {
  deltaEndMinMean: number | null
  deltaTargetPpMean: number | null
  liveCostAtComposite: number | null
  liveFeasibleShare: number | null
  nTightened: number | null
  optimizationId: string | null
  planCostAtComposite: number | null
}
export type VehicleOutcomeOut = {
  metTarget: boolean | null
  realisedCost: number | null
  realisedDeparture: string | null
  realisedKgco2: number | null
  realisedKwh: number | null
  realisedSocDepart: number | null
  vehicleId: string
}
export type PlanOutcomeOut = {
  planId: string
  shadow: ShadowComparisonOut | null
  vehicles: VehicleOutcomeOut[]
}
export type OutcomePageOut = {
  from: string
  nextCursor: string | null
  outcomesAvailable: boolean
  pageSize: number
  plans: PlanOutcomeOut[]
  siteId: string
  to: string
}
export type ReadinessOut = {
  atRisk: number
  onTrack: number
  watch: number
}
export type SolverSummaryOut = {
  durationS?: number | null
  gap?: number | null
  method?: string | null
  status: string
}
export type PlanVersionSummaryOut = {
  author: PlanAuthorOut
  currency: string | null
  expectedMisses: number | null
  flags: string[]
  issuedAt: string
  kind: 'HEARTBEAT' | 'EVENT' | 'DAY_AHEAD' | 'PREVIEW'
  label: string | null
  mode: 'REPLAY' | 'LIVE'
  nextSolveAt: string | null
  objectiveTotal: number | null
  optimizerInputEligible: boolean
  parentPlanId: string | null
  planId: string
  previewId: string | null
  readiness: ReadinessOut | null
  solver: SolverSummaryOut
  trigger: string
  validUntil: string
  violations: number
  writtenAt: string | null
}
export type PlanVersionPageOut = {
  from: string
  nextCursor: string | null
  pageSize: number
  siteId: string
  timeZone: string
  to: string
  versions: PlanVersionSummaryOut[]
}
export type DiffBlockOut = {
  avgKw: number
  blockId: string
  chargerId: string | null
  connectorId: string | null
  dischargeKw: number
  end: string
  start: string
}
export type DiffChangeOut = {
  after: DiffBlockOut | null
  before: DiffBlockOut | null
  departureOk: boolean
  kind: 'moved' | 'added' | 'removed' | 'v2g'
  pinned: boolean
  reason: SentenceOut
  vehicleId: string
}
export type PlanRefOut = {
  label: string
  planId: string
}
export type DiffSummaryOut = {
  added: number
  moved: number
  pinnedListed: number
  removed: number
  v2g: number
}
export type PlanDiffOut = {
  author: PlanAuthorOut | null
  changes: DiffChangeOut[]
  from: PlanRefOut
  summary: DiffSummaryOut
  to: PlanRefOut
  trigger: string | null
}
export type PlanDiffBodyOut = {
  diff: PlanDiffOut
}
export type ExplainInputsOut = {
  feeds: FeedOut[]
  inputsHash: string
  modelVersions: ModelVersionOut[]
}
export type PlanExplainOut = {
  bindingConstraints: BindingConstraintOut[]
  excludedVehicles: ExcludedVehicleOut[]
  explanation: ExplanationOut
  inputs: ExplainInputsOut
  objective: ObjectiveOut
  planId: string
}
export type ForecastAdherenceOut = {
  meanDelayMin: number
  n: number
  windowDays: number
}
export type ForecastObservationOut = {
  lastObservedAt: string | null
  observationAgeS: number | null
  provider: string | null
}
export type ForecastProvenanceOut = {
  basis: string | null
  issuedAt: string
  kind: string
  modelVersion: string | null
  source: string
}
export type ForecastSubjectOut = {
  id: string
  type: 'vehicle' | 'route' | 'site'
}
export type ForecastOut = {
  adherence?: ForecastAdherenceOut | null
  forecastId: string
  issuedAt: string
  kind: string
  modelVersion?: string | null
  observation?: ForecastObservationOut | null
  p10: string | number | null
  p50: string | number | null
  p90: string | number | null
  provenance: ForecastProvenanceOut
  quantity: string
  reference: unknown
  subject: ForecastSubjectOut
  unit: string
  widened: boolean
  widenedReason?: string | null
}
export type ForecastListOut = {
  forecasts: ForecastOut[]
  label: string
  planId: string
}
export type OptionsBudgetUseOut = {
  limitS: number
  usedS: number
}
export type PlanOptionsOut = {
  baseline: BaselineOut
  budget: OptionsBudgetUseOut
  excludedVehicles: ExcludedVehicleOut[]
  options: OptionOut[]
  truncated: boolean
}
export type TimelineBlockOut = {
  avgKw: number
  blockId: string
  chargerId: string | null
  connectorId: string | null
  dischargeKw: number
  end: string
  start: string
  vehicleId: string
}
export type TimelineSlotOut = {
  composite: number | null
  envelopeP50Kw: number | null
  envelopeP90Kw: number | null
  minutes: number | null
  moer: number | null
  plannedImportKw: number | null
  price: number | null
  siteLimitKw: number | null
  slotStart: string
  visitorKw: number | null
}
export type PlanTimelineOut = {
  blocks: TimelineBlockOut[]
  horizon: HorizonOut
  label: string
  planId: string
  slots: TimelineSlotOut[]
  slotsUnavailableReason: ('lake_disabled' | 'not_found' | 'not_solved') | null
}
export type VerdictListOut = {
  label: string
  planId: string
  verdicts: VerdictOut[]
}
export type SiteForecastPointOut = {
  at: string
  temperature?: number | null
  until: string
}
export type OmittedReason = 'vehicle_limit'
export type OmittedOut = {
  count: number
  reason?: OmittedReason | null
}
export type Resolution = 'hour' | 'block'
export type SiteEvaluationPointOut = {
  at: string
  confidence: number
  efficiency: number
  multiplier: number
  source: string
}
export type SiteVehicleSummaryOut = {
  endEfficiency?: number | null
  forecastCoverage: number
  meanChange?: number | null
  meanEfficiency?: number | null
  meanMultiplier?: number | null
  peakAt?: string | null
  peakEfficiency?: number | null
  startEfficiency?: number | null
  startToEndChange?: number | null
}
export type UnavailableReason = 'efficiency_model_missing' | 'baseline_missing' | 'upstream_failed'
export type SiteVehicleEvaluationOut = {
  baseline?: number | null
  baselineSource?: BaselineSource | null
  cohort?: CohortOut | null
  confidence?: number | null
  fallbackLevel?: FallbackLevel | null
  model?: ModelOut | null
  name?: string | null
  points?: SiteEvaluationPointOut[]
  residualAdjustment?: number | null
  status?: EfficiencyModelStatus | null
  summary?: SiteVehicleSummaryOut | null
  unavailableReason?: UnavailableReason | null
  vehicleId: string
}
export type SiteEvaluationOut = {
  forecast: SiteForecastPointOut[]
  from: string
  omitted: OmittedOut
  resolution: Resolution
  siteId: string
  temperatureSource: TemperatureSource
  to: string
  vehicles: SiteVehicleEvaluationOut[]
}
export type VisitEventOut = {
  at: string
  confidence: number
  eventId: string
  kind: 'ENTER' | 'LEAVE'
  place: PlaceRefOut
  quality: string
  vehicleId: string
  visitId: string
}
export type SiteDayCoverageOut = {
  dense: number
  hourly: number
  none: number
  sparse: number
  vehicles: number
}
export type VisitRefOut = {
  enterAt: string
  leaveAt?: string | null
  vehicleId: string
  visitId: string
}
export type SiteDayOut = {
  arrivals: VisitEventOut[]
  coverage: SiteDayCoverageOut
  date: string
  departures: VisitEventOut[]
  onSiteAtEnd: VisitRefOut[]
  onSiteAtStart: VisitRefOut[]
  siteId: string
  timeZone: string
  truncated?: boolean
}
export type CapacitySource = 'REQUEST' | 'VEHICLE' | 'CAPABILITY_SET'
export type EfficiencySource = 'MODEL' | 'DEFAULT'
export type EnergyBasis = 'BATTERY' | 'GRID'
export type LimitedBy = 'CHARGER' | 'VEHICLE' | 'SCHEDULE_PAUSED'
export type ChargeDurationSegmentOut = {
  endAt?: string | null
  fromSoc: number
  limitedBy: LimitedBy
  minutes: number
  powerFrom: number
  powerTo: number
  startAt?: string | null
  toSoc: number
}
export type ChargeDurationOut = {
  batteryCapacity: number
  batteryCapacitySource: CapacitySource
  batteryEnergy: number
  capabilitySetId: string
  chargerClass: ChargerClass
  chargerClassInferred: boolean
  chargingEfficiency: number
  chargingEfficiencySource: EfficiencySource
  clampedAtFull: boolean
  completed: boolean
  confidence?: number | null
  curveChargerClass?: ChargerClass | null
  curveSource: EffectiveCurveSource
  endAt?: string | null
  endSoc: number
  energyBasis: EnergyBasis
  fallbackLevel: ChargeFallbackLevel
  gridEnergy: number
  holdoutBasis?: string | null
  holdoutBiasShare?: number | null
  holdoutMedianApe?: number | null
  interpolation: PowerCurveInterpolation
  minutes: number
  segments: ChargeDurationSegmentOut[]
  startAt?: string | null
  startSoc: number
  targetSoc: number
  vehicleId: string
}
export type CurrentType = 'AC' | 'DC'
export type PowerScheduleEntryIn = {
  from: string
  maxPower: number
  until?: string | null
}
export type ChargeDurationIn = {
  batteryCapacity?: number | null
  chargerClass?: ChargerClassParam | null
  currentType?: CurrentType | null
  energy?: number | null
  energyBasis?: EnergyBasis
  maxPower?: number | null
  powerSchedule?: PowerScheduleEntryIn[] | null
  startAt?: string | null
  startSoc: number
  targetSoc?: number | null
}
export type RebuildQueuedOut = {
  reason: string
  state: string
  vehicleId: string
}
export type EvaluationPointOut = {
  at: string
  confidence: number
  efficiency: number
  efficiencyQuantiles?: QuantilesOut | null
  multiplier: number
  residualAdjustment: number
  residualMultiplier?: QuantilesOut | null
  source: string
  temperature?: number | null
  until: string
}
export type EvaluationOut = {
  baseline: number
  fallbackLevel: FallbackLevel
  from: string
  model: ModelOut
  points: EvaluationPointOut[]
  residualModel?: ResidualModelOut | null
  resolution: Resolution
  siteId?: string | null
  temperatureSource: TemperatureSource
  to: string
  vehicleId: string
}
export type AccuracyOut = {
  inSample: boolean
  modelBias?: number | null
  /** Deprecated: unbounded for low-efficiency samples; use modelWape. */
  modelMape?: number | null
  modelMedianApe?: number | null
  modelWape?: number | null
  sampleCount: number
  sampleFrom?: string | null
  sampleTo?: string | null
  staticBias?: number | null
  /** Deprecated: unbounded for low-efficiency samples; use staticWape. */
  staticMape?: number | null
  staticMedianApe?: number | null
  staticWape?: number | null
  /** Deprecated: use sampleCount. Same value, removed one release after the UI reads sampleCount. */
  tripCount: number
  underForecastShare?: number | null
}
export type HistoryBucketSize = 'WEEK' | 'MONTH'
export type HistoryBucketOut = {
  distance?: number | null
  efficiency?: number | null
  end: string
  energy?: number | null
  maxTemperature?: number | null
  meanPayload?: number | null
  meanTemperature?: number | null
  minTemperature?: number | null
  modelledEfficiency?: number | null
  payloadSampleCount: number
  /** Deprecated: use payloadSampleCount. Same value, removed one release after the UI reads payloadSampleCount. */
  payloadTripCount: number
  sampleCount: number
  start: string
  temperatureCoverage?: number | null
  trainableSampleCount: number
  /** Deprecated: use trainableSampleCount. Same value, removed one release after the UI reads trainableSampleCount. */
  trainableTripCount: number
  /** Deprecated: use sampleCount. Same value, removed one release after the UI reads sampleCount. */
  tripCount: number
  weatherNormalisedEfficiency?: number | null
}
export type CurveSource = 'VEHICLE' | 'COHORT' | 'NONE' | 'PRIOR'
export type HistoryModelOut = {
  baselineEfficiency?: number | null
  cohortId?: string | null
  cohortType?: CohortType2 | null
  confidence?: number | null
  curveSource: CurveSource
  fallbackLevel: FallbackLevel
  lastFittedAt?: string | null
  maxTemperature?: number | null
  minTemperature?: number | null
  resetAt?: string | null
  /** What the model row's samples are: the kind the model row's sampleCount counts. The row's own provenance, read off its modelVersion (a block suffix is BLOCK, any other version TRIP); when the version says nothing (a legacy 1.0.0 or empty version) the fitter's EFFICIENCY_SAMPLE_SOURCE in this environment (BLOCKS is BLOCK, FM_TRIPS is TRIP). UNKNOWN is never emitted here. The history's own sampleKind (top level) is what the buckets count; the two differ when the row was fitted on another kind of sample than the history reads. */
  sampleKind: SampleKind
  status: EfficiencyModelStatus
  trainingFrom?: string | null
}
export type PayloadPointOut = {
  efficiency: number
  payload: number
  temperature?: number | null
}
export type PayloadSummaryOut = {
  maxPayload?: number | null
  minPayload?: number | null
  points: PayloadPointOut[]
  sampleCount: number
  slope?: number | null
  /** The kind of samples slope was fitted on: the model row's own provenance, read off its modelVersion (a block suffix is BLOCK, any other version TRIP), else the fitter's EFFICIENCY_SAMPLE_SOURCE in this environment when the version says nothing (UNKNOWN is never emitted here); null when slope is null. Draw the slope over the points only when it equals the history's sampleKind. */
  slopeBasis?: SampleKind | null
  /** Deprecated: use sampleCount. Same value, removed one release after the UI reads sampleCount. */
  tripCount: number
  /** What the payload axis (payload, minPayload, maxPayload, points[].payload) measures. GROSS_COMBINATION: the gross combination vehicle weight in kg as the telemetry reports it, tare included, which both sources store as the sample's payload. The one value today. */
  weightKind: 'GROSS_COMBINATION'
}
export type HistorySource = 'FM_SAMPLES' | 'BLOCK_STATE'
export type HistoryArtifactStatus = 'servable' | 'not_servable' | 'missing' | 'invalid'
export type HistoryStatusOut = {
  artifact: HistoryArtifactStatus
  /** The artifact's end of data (same as the top-level dataThrough); null when there is no artifact. */
  dataThrough?: string | null
  /** The artifact holds only the newest rows (the writer's 5,000-row bound was reached). */
  truncated: boolean
}
export type TemperatureBinOut = {
  actualMedian?: number | null
  actualP25?: number | null
  actualP75?: number | null
  binEnd: number
  binStart: number
  cohort?: number | null
  curve?: number | null
  sampleCount: number
  /** Deprecated: use sampleCount. Same value, removed one release after the UI reads sampleCount. */
  tripCount: number
}
export type HistoryOut = {
  accuracy?: AccuracyOut | null
  bucket: HistoryBucketSize
  buckets: HistoryBucketOut[]
  /** BLOCK_STATE only: the end of the data the blocks cover (the start of the closing charge of the newest block, else how far the state was read); null for FM_SAMPLES and when there is no artifact. The window is not clamped to it: a block exists once its charge has passed (plus about two hours), so the newest drives can be missing, and a bucket after dataThrough is incomplete, not zero. */
  dataThrough?: string | null
  /** Samples left out of every figure above because their efficiency is outside the plausibility band (0.15 to 3.0 kWh/km, inclusive). Neither source flags such samples, so this count is the only trace of them; they still count in each bucket's sampleCount. */
  excludedImplausible: number
  from: string
  model: HistoryModelOut
  /** The payload scatter; null below 10 payload-bearing trainable samples. On BLOCK_STATE the payload is the block's gross-weight median where the artifact carries the payload columns (a blocks function with EFFICIENCY_BLOCKS_PAYLOAD_ENABLED), else null. */
  payload?: PayloadSummaryOut | null
  sampleDefinition?: string | null
  sampleKind: SampleKind
  /** Where the samples came from: FM_SAMPLES (fleet-management's per-trip samples) or BLOCK_STATE (the history/1 artifact of the block state). With BLOCK_STATE the answer never falls back to fleet-management's samples: a vehicle without a usable artifact gets empty buckets, no temperature bins, no accuracy and no payload. */
  source: HistorySource
  staticEfficiency?: number | null
  /** BLOCK_STATE only (null for FM_SAMPLES): the state of the vehicle's artifact (servable, not_servable, missing or invalid), whether it holds only the newest rows, and how far the data goes. An empty history with artifact `servable` is a vehicle that did not drive; with any other artifact status there are no blocks to show. */
  status?: HistoryStatusOut | null
  temperatureBins: TemperatureBinOut[]
  timeZone: string
  to: string
  vehicleId: string
  /** BLOCK_STATE only: when the artifact was last written (nightly); null for FM_SAMPLES and when there is no artifact. */
  writtenAt?: string | null
}
export type ResetIn = {
  reason: string
  trainingFrom?: string | null
}
export type BlockSampleOut = {
  ambientTemperature?: number | null
  distance?: number | null
  duration?: number | null
  efficiency?: number | null
  endedAt: string
  energy?: number | null
  energySource?: string | null
  quality?: string[]
  startedAt: string
  temperatureSampleCount?: number | null
  temperatureSource?: string | null
  tripId: string
}
export type BlockSamplesOut = {
  kind?: 'BLOCK'
  page: number
  pageSize: number
  samples: BlockSampleOut[]
  total: number
  vehicleId: string
}
export type SampleKindParam = 'BLOCK'
export type SocQuantilesOut = {
  p10: number
  p50: number
  p90: number
}
export type DepartureOut = {
  censored?: boolean
  p10?: string | null
  p50?: string | null
  p90?: string | null
  pWithinHorizon: number
}
export type NetworkSiteOut = {
  p: number
  siteId: string
}
export type PluggedInOut = {
  home: number
  networkSites: NetworkSiteOut[]
  offNetwork: number
  otherNetwork: number
  unknown: number
}
export type PlugInOut = {
  censored?: boolean
  location?: PluggedInOut | null
  p10?: string | null
  p50?: string | null
  p90?: string | null
  pWithinHorizon: number
}
export type EventsOut = {
  /** By location: home, otherNetwork, offNetwork, unknown, or `site:<siteId>`. */
  arrivalSoc?: {
    [key: string]: SocQuantilesOut
  }
  nextDeparture?: DepartureOut | null
  nextPlugIn?: PlugInOut | null
}
export type StateFallbackLevel = 'VEHICLE_MODEL' | 'PROFILE' | 'COHORT_PROFILE'
export type StateForecastModelOut = {
  name?: string
  version: string
}
export type StateSlotOut = {
  at: string
  pActive: number
  pIdle: number
  pPluggedIn: number
  pluggedIn: PluggedInOut
  until: string
}
export type StateForecastStatus = 'SERVED' | 'STALE' | 'PROFILE_ONLY' | 'LOW_COVERAGE'
export type StateForecastOut = {
  dataCoverage: number
  dataThrough: string
  events?: EventsOut | null
  fallbackLevel: StateFallbackLevel
  flags?: string[]
  issuedAt: string
  model: StateForecastModelOut
  slots?: StateSlotOut[] | null
  status: StateForecastStatus
  vehicleId: string
}
export type StateForecastResolution = '15m' | 'hour'
export type VisitEventListOut = {
  data: VisitEventOut[]
  freshness?: FreshnessOut | null
  hasMore: boolean
  nextCursor?: string | null
  object?: 'list'
}
export type VisitSummaryDayOut = {
  arrivals: number
  coverageClass?: string | null
  date: string
  departures: number
  dwellSecondsByPlace: {
    [key: string]: number
  }
  firstDepartureAt?: string | null
  fixCount?: number | null
  homeDwellSeconds: number
  lastArrivalAt?: string | null
  visits: number
}
export type VisitSummaryOut = {
  days: VisitSummaryDayOut[]
  freshness?: FreshnessOut | null
  from: string
  timeZone: string
  to: string
  vehicleId: string
}
export const {
  useGetModelQuery,
  useLazyGetModelQuery,
  useUpsertModelMutation,
  useListWmisQuery,
  useLazyListWmisQuery,
  useSaveWmiMutation,
  useUpdatePowerCurveMutation,
  useDeletePowerCurveMutation,
  useFitPowerCurveMutation,
  useGetManufacturerQuery,
  useLazyGetManufacturerQuery,
  useUpdateManufacturerMutation,
  useDeleteManufacturerMutation,
  useGetMakeModelQuery,
  useLazyGetMakeModelQuery,
  useUpdateMakeModelMutation,
  useDeleteMakeModelMutation,
  useGetCapabilitySetQuery,
  useLazyGetCapabilitySetQuery,
  useUpdateCapabilitySetMutation,
  useDeleteCapabilitySetMutation,
  useGetCohortQuery,
  useLazyGetCohortQuery,
  useUpsertCohortMutation,
  useGetChargeModelQuery,
  useLazyGetChargeModelQuery,
  useUpsertChargeModelMutation,
  useResetModelMutation,
  useProposeMutation,
  useListPowerCurvesQuery,
  useLazyListPowerCurvesQuery,
  useCreatePowerCurveMutation,
  useListManufacturersQuery,
  useLazyListManufacturersQuery,
  useCreateManufacturerMutation,
  useMergeManufacturerMutation,
  useListMakeModelsQuery,
  useLazyListMakeModelsQuery,
  useCreateMakeModelMutation,
  useListSignaturesQuery,
  useLazyListSignaturesQuery,
  useCreateSignatureMutation,
  useMergeMakeModelMutation,
  useListCapabilitySetsQuery,
  useLazyListCapabilitySetsQuery,
  useCreateCapabilitySetMutation,
  useResetModelsMutation,
  useBackfillMutation,
  useResetChargeModelMutation,
  useMoveApiKeyToUsagePlanMutation,
  useRegisterApiKeyByOrganizationIdMutation,
  useGetUsagePlanByOrganizationIdQuery,
  useLazyGetUsagePlanByOrganizationIdQuery,
  useUpdateUsagePlanByOrganizationIdMutation,
  useUpdateApiKeyByOrganizationIdMutation,
  useGetVehicleCapabilitySetQuery,
  useLazyGetVehicleCapabilitySetQuery,
  useGetSamplesQuery,
  useLazyGetSamplesQuery,
  useGetWmiQuery,
  useLazyGetWmiQuery,
  useDeleteWmiMutation,
  useGetVinDecodeQuery,
  useLazyGetVinDecodeQuery,
  useListCapabilitySetVehiclesQuery,
  useLazyListCapabilitySetVehiclesQuery,
  useListModelsQuery,
  useLazyListModelsQuery,
  useListCohortsQuery,
  useLazyListCohortsQuery,
  useListChargeModelsQuery,
  useLazyListChargeModelsQuery,
  useGetUsagePlansByOrganizationIdQuery,
  useLazyGetUsagePlansByOrganizationIdQuery,
  useGetApiKeyUsageByOrganizationIdQuery,
  useLazyGetApiKeyUsageByOrganizationIdQuery,
  useGetApiKeySummariesByOrganizationIdQuery,
  useLazyGetApiKeySummariesByOrganizationIdQuery,
  useDeleteSignatureMutation,
  useCapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetQuery,
  useLazyCapabilitySetChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveGetQuery,
  useRefitChargeCurveV1CapabilitySetsCapabilitySetIdChargeCurveRefitPostMutation,
  useCapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetQuery,
  useLazyCapabilitySetChargeModelV1CapabilitySetsCapabilitySetIdChargeModelGetQuery,
  useEstimateEnergyV1EnergyEstimatesPostMutation,
  useFitChargeCurvesV1FitsChargeCurvesPostMutation,
  useFitEfficiencyV1FitsEfficiencyPostMutation,
  useLatestFitRunV1FitsRunsLatestGetQuery,
  useLazyLatestFitRunV1FitsRunsLatestGetQuery,
  useHealthV1HealthGetQuery,
  useLazyHealthV1HealthGetQuery,
  useListPlacesV1PlacesGetQuery,
  useLazyListPlacesV1PlacesGetQuery,
  useGetPlaceV1PlacesPlaceIdGetQuery,
  useLazyGetPlaceV1PlacesPlaceIdGetQuery,
  useListPlaceVisitsV1PlacesPlaceIdVisitsGetQuery,
  useLazyListPlaceVisitsV1PlacesPlaceIdVisitsGetQuery,
  useListPlanEvaluationsV1PlansEvaluationsGetQuery,
  useLazyListPlanEvaluationsV1PlansEvaluationsGetQuery,
  useGetPlanEvaluationV1PlansEvaluationsDayGetQuery,
  useLazyGetPlanEvaluationV1PlansEvaluationsDayGetQuery,
  useGetPlansEnvironmentHealthV1PlansHealthGetQuery,
  useLazyGetPlansEnvironmentHealthV1PlansHealthGetQuery,
  useComparePlansV1PlansSitesSiteIdCompareGetQuery,
  useLazyComparePlansV1PlansSitesSiteIdCompareGetQuery,
  useGetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetQuery,
  useLazyGetDayAheadPlanV1PlansSitesSiteIdDayAheadServiceDateGetQuery,
  useGetPlansSiteHealthV1PlansSitesSiteIdHealthGetQuery,
  useLazyGetPlansSiteHealthV1PlansSitesSiteIdHealthGetQuery,
  useListPlanModelsV1PlansSitesSiteIdModelsGetQuery,
  useLazyListPlanModelsV1PlansSitesSiteIdModelsGetQuery,
  useListPlanOutcomesV1PlansSitesSiteIdOutcomesGetQuery,
  useLazyListPlanOutcomesV1PlansSitesSiteIdOutcomesGetQuery,
  useListPlanVersionsV1PlansSitesSiteIdVersionsGetQuery,
  useLazyListPlanVersionsV1PlansSitesSiteIdVersionsGetQuery,
  useGetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetQuery,
  useLazyGetPlanVersionV1PlansSitesSiteIdVersionsPlanIdGetQuery,
  useDiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetQuery,
  useLazyDiffPlanV1PlansSitesSiteIdVersionsPlanIdDiffGetQuery,
  useExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetQuery,
  useLazyExplainPlanV1PlansSitesSiteIdVersionsPlanIdExplanationsGetQuery,
  useListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetQuery,
  useLazyListPlanForecastsV1PlansSitesSiteIdVersionsPlanIdForecastsGetQuery,
  useListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetQuery,
  useLazyListPlanOptionsV1PlansSitesSiteIdVersionsPlanIdOptionsGetQuery,
  useGetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetQuery,
  useLazyGetPlanOptionV1PlansSitesSiteIdVersionsPlanIdOptionsOptionIdGetQuery,
  useGetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetQuery,
  useLazyGetPlanTimelineV1PlansSitesSiteIdVersionsPlanIdTimelineGetQuery,
  useListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetQuery,
  useLazyListPlanVerdictsV1PlansSitesSiteIdVersionsPlanIdVerdictsGetQuery,
  useEvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetQuery,
  useLazyEvaluateSiteEfficiencyV1SitesSiteIdEfficiencyEvaluateGetQuery,
  useSiteVisitsDayV1SitesSiteIdVisitsDaysDateGetQuery,
  useLazySiteVisitsDayV1SitesSiteIdVisitsDaysDateGetQuery,
  useVehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetQuery,
  useLazyVehicleChargeCurveV1VehiclesVehicleIdChargeCurveGetQuery,
  useVehicleChargeDurationV1VehiclesVehicleIdChargeDurationPostMutation,
  useGetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetQuery,
  useLazyGetEfficiencyModelV1VehiclesVehicleIdEfficiencyGetQuery,
  useRebuildBlocksV1VehiclesVehicleIdEfficiencyBlocksRebuildPostMutation,
  useRefitEfficiencyModelV1VehiclesVehicleIdEfficiencyModelRefitPostMutation,
  useEvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetQuery,
  useLazyEvaluateEfficiencyV1VehiclesVehicleIdEfficiencyEvaluateGetQuery,
  useEfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetQuery,
  useLazyEfficiencyHistoryV1VehiclesVehicleIdEfficiencyHistoryGetQuery,
  useResetEfficiencyModelV1VehiclesVehicleIdEfficiencyResetPostMutation,
  useEfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetQuery,
  useLazyEfficiencySamplesV1VehiclesVehicleIdEfficiencySamplesGetQuery,
  useGetStateForecastV1VehiclesVehicleIdStateForecastGetQuery,
  useLazyGetStateForecastV1VehiclesVehicleIdStateForecastGetQuery,
  useListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetQuery,
  useLazyListVehicleVisitEventsV1VehiclesVehicleIdVisitEventsGetQuery,
  useListVehicleVisitsV1VehiclesVehicleIdVisitsGetQuery,
  useLazyListVehicleVisitsV1VehiclesVehicleIdVisitsGetQuery,
  useVehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetQuery,
  useLazyVehicleVisitSummaryV1VehiclesVehicleIdVisitsSummaryGetQuery,
  useListOpenVisitsV1VisitsOpenGetQuery,
  useLazyListOpenVisitsV1VisitsOpenGetQuery
} = injectedRtkApi
